import React, { Component } from "react";
// react component for creating dynamic tables
import axios from 'axios'
import Moment from 'moment'
import path from 'path';
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Col,
  Button,
  FormGroup,
  Form,
  Input,
  Row,
  Table,
  Collapse,
  UncontrolledTooltip,
  Modal,
  ButtonGroup,
  ModalHeader,
  ModalBody,
  Breadcrumb,
  BreadcrumbItem,
  Badge,
  DropdownToggle,
  DropdownMenu, 
  DropdownItem, 
  UncontrolledDropdown, 
  ButtonDropdown, 
  ListGroup, 
  ListGroupItem

} from "reactstrap";
import {
  Link
} from "react-router-dom";
import { imageFileExtension, getImageFile, getRandomRolor } from "../../settings/shared/commonMethod"
import Select from 'react-select';
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import RunService from '../../services/api/Run';

import ProjectService from '../../services/api/Project';
import CommonService from '../../services/api/Common';
import ClusterService from '../../services/api/Cluster';
import ImageService from '../../services/api/MachineImages';
import StorageService from '../../services/api/Storage';
import { toast } from 'react-toastify';
import { fileSizeSI, provisionerTypeLogo } from '../../settings/shared/commonMethod'
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay'
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import 'react-web-tabs/dist/react-web-tabs.css';
import dfrepo from "assets/img/df.png";
import TinyURL from "tinyurl";
import open from "assets/img/open.png";
import { Scrollbars } from 'react-custom-scrollbars';
import ChipInput from 'material-ui-chip-input'
import Chip from '@material-ui/core/Chip';
import { uuidv4 } from '../../components/Notebook/operations/notebook'
import moment from 'moment'
import ReactTable from "react-table";
import Scheduler from "../../components/Scheduler/Scheduler_copy2";
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-python';

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)


const delimiteroptions = [
  { label: "Comma Seperated Value (,)", value: "," },
  { label: "Pipe Seperated Value (|)", value: "|" }
];
const styles = {
  cursor: {
    cursor: 'pointer'
  },
  leftAlign: {
    marginLeft: 35
  },
  rowAlign: {
    marginTop: 28
  },
  errorBox: {
    textAlign: "center",
    marginBottom: 20
  },
  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
  textAreaHint: {
    color: "#000",
    fontSize: 12
  }
}

const AddStorageItems = props => {
  let items = [];
  const { folders, files, nextPageToken, loadmoreFlag } = props;

  const findIcon = contentType => {
    if (!contentType) {
      return 'fas fa-file'
    } else if (contentType.startsWith('audio/')) {
      return 'fas fa-file-audio'
    } else if (contentType.startsWith('image/')) {
      return 'fas fa-file-image'
    } else if (contentType.startsWith('text/')) {
      return 'fas fa-file-alt'
    } else {
      return 'fas fa-file-alt'
    }
  };

  const trimFolderName = folderName => {
    if (folderName.endsWith('/')) {
      folderName = folderName.slice(0, -1);
    }
    return folderName.split('/').pop()
  };

  const trimFileName = fileName => {
    return fileName.split('/').pop()
  };

  const fileCheckClicked = event => {
    event.preventDefault()
    event.stopPropagation()
    let updateFlag = null
    if (event.target.dataset.checked === "0") {
      event.target.className = "fas fa-check-square pr-2"
      event.target.dataset.checked = "1"
      updateFlag = true
    } else {
      event.target.className = "far fa-square pr-2"
      event.target.dataset.checked = "0"
      updateFlag = false
    }
    if (event.target.dataset.type === 'folder') {
      props.updateStorageFolders(event.target.dataset.name, updateFlag)
    } else {
      props.updateStorageFiles(event.target.dataset.name, updateFlag)
    }
  }

  const onFolderClick = event => {
    event.preventDefault()
    props.fetchStorageItems(event.target.dataset.name)
  }

  for (const folder of folders) {
    const folderFound = (props.storageFoldersToBeAdded.indexOf(folder) > -1) || props.selectAllFiles
    items.push(
      <Row
        tag="a"
        className="py-2"
      >
        <Col md="6" xs="6">
          <span
            className="folder"
            data-type="folder"
            data-name={folder}
            onClick={onFolderClick}
            id={folder}
          >
            <i
              data-type="folder"
              data-name={folder}
              data-full_path={folder}
              data-checked={folderFound ? "1" : "0"}
              className={folderFound ? "fas fa-check-square pr-2" : "far fa-square pr-2"}
              onClick={fileCheckClicked}
            ></i>
            <i className="fas fa-folder pr-1"></i>{trimFolderName(folder)}
          </span>
        </Col>
        <Col md="2" xs="2">--</Col>
        <Col md="4" xs="4">--</Col>
      </Row>
    )
  }

  for (const file of files) {
    const fileFound = (props.storageFilesToBeAdded.indexOf(file.name) > -1) || props.selectAllFiles
    items.push(
      <Row
        tag="a"
        className="py-2"
      >
        <Col md="6" xs="6">

          <span
            className="add-storage-file"
            data-type="file"
          >
            <i
              data-type="file"
              data-name={file.name}
              data-full_path={file.full_path}
              data-checked={fileFound ? "1" : "0"}
              className={fileFound ? "fas fa-check-square pr-2" : "far fa-square pr-2"}
              onClick={fileCheckClicked}
            ></i>
            <i className={findIcon(file.content_type) + " pr-1"}></i>
            {' '}{trimFileName(file.name)}
          </span>
        </Col>
        <Col md="2" xs="2">{fileSizeSI(file.size)}</Col>
        <Col md="4" xs="4">{Moment(file.created).format('MMMM Do, YYYY hh:mma')}</Col>
      </Row>
    )
  }

  if (nextPageToken !== null || nextPageToken === null) {
    items.push(
      <>
        <Row
          tag="a"
          className=""
          key={uuidv4()}
          style={{ minHeight: '10px', color: 'white' }}
        >
          <span className="folder">. </span>
          <Col md="7" xs="7" className="">

          </Col>
          <Col md="2" xs="2" className="storagetxt"></Col>
          <Col md="3" xs="3" className="storagetxt"></Col>
        </Row>
        <Row>
          <Col style={{ textAlign: "center" }}>
            {nextPageToken !== null && loadmoreFlag && <ButtonGroup className="chatLoading" style={{ verticalAlign: 'sub' }}>
              <Badge color="info"> Loading... </Badge>
            </ButtonGroup>}
          </Col>
        </Row>
      </>
    )
  }

  return items
}

class Project extends Component {
  constructor(props) {
    super(props);
    if (this.props.location.state === undefined) {
      this.props.history.push("/project")
      window.location.reload(true);
    }
    else {
      this.props.location.state.mode = this.props.location.state.mode
    }
     // Set initial files, type 'local' means this is a file
    this.state = {
      files: [],
      pythonfiles: [],
      files_input: [],
      files_code: [],
      storageFilesToBeAdded: [],
      storageFoldersToBeAdded: [],
      setFiles_input: [],
      setFiles_code: [],
      setFolders_input: [],
      setFolders_code: [],
      recentUploadpassInput: '',
      recentUploadpassCode: '',
      btnActions: "",
      iconaction: "",
      recentFilesInput: [],
      recentFilesCode: [],
      recentInputfolders: [],
      recentCodefolders: [],
      runId: null,
      nextPageToken: null,
      checkboxStateCode: false,
      checkboxStateInput: false,
      inputFlag: true,
      codeFlag: true,
      StorageFlag: false,
      chooseType: "",
      runDBId: null,
      clusterName: '',
      clusterId: null,
      kernelName: '',
      kernelId: null,
      delimiter: ',',
      parameterSet: '',
      pyLibrary: '',
      rname: '',
      description: '',
      openedadvanceCollapses: ["collapseAdvance"],
      openedCollapses: [""],
      hTabs: "ht1",
      addedStorageItem: [],
      showAddStorageModal: false,
      currFolder: null,
      storageNavigations: [],
      storageFolders: [],
      storageFiles: [],
      selectAllFiles: false,
      selectAllFilesClass: 'far fa-square pr-2',
      showUploadModal: false,
      editId: '',
      runPId: '',
      copied: false,
      value: '',
      sharefile: false,
      sharetinyurl: '',
      gettinylink: '',
      copylink: '',
      modalParameter: false,
      inputCodeFilesRequired: false,
      inputFilesRequired: false,
      advanceicon: "fas fa-minus-circle",
      clusteroptions: [],
      clusterTemp: [],
      tags: [],
      open: false,
      rerunFromSavedInputFiles: false,
      rerunFromSavedCodeFiles: false,
      parametercolumns: [],
      parametersTablesdata: [],
      detailedView_ParamSet: "",
      runTimeOptions: [],
      deleteParameter: false,
      newparameterset: '',
      pagehist: '',
      loadmoreFlag: false,
      //Scheduler Relevant
      runDropDown: false,
      showScheduler: false,
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      machineId: null,
      computeType: null,
      clusterLable: null,
      vmTypes: [],
      clusterTypes: [],
      hintVmCluster: "",
      hintRunTime: "",
      hintName: "",
      hintCodeFiles: "",
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.state.columns = [
      {
        Header: 'Id',
        accessor: 'Id',
        sortable: true,
        show: false
      },
      {
        Header: 'Cluster Name',
        accessor: 'ClusterName',
        maxWidth: 200,
        sortable: true,
      },
      {
        Header: 'Description',
        accessor: 'Description',
        maxWidth: 200,

      },
      {
        Header: 'Status',
        accessor: 'Status',
        maxWidth: 100,
      },
      {
        Header: 'Monthly Usage',
        accessor: 'MonthlyUsage',
        maxWidth: 120,
      },
      {
        Header: 'Cost',
        accessor: 'Cost',
        maxWidth: 100,
      },
      {
        Header: 'Created By',
        accessor: 'Created',
        maxWidth: 100,
      }, {
        Header: 'Last Modified',
        accessor: 'Lastmodified',
        maxWidth: 150,
      },
      {
        Header: 'Actions',
        accessor: 'Actions',
        maxWidth: 135,

      }
    ];
    this.state.parametercolumns = [
      {
        Header: 'Variables',
        accessor: 'Variables',
        maxWidth: 100
      },
      {
        Header: 'Values',
        accessor: 'Values',
        sortable: true,
      },
      {
        Header: 'Description',
        accessor: 'Description',
        maxWidth: 200
      }
    ];
  }
  collapsesToggle = collapse => {
    let openedCollapses = this.state.openedCollapses;

    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: []
      });
    } else {
      this.setState({
        openedCollapses: [collapse]
      });
    }

  };
  collapsesAdvanceToggle = collapse => {
    let openedadvanceCollapses = this.state.openedadvanceCollapses;
    if (openedadvanceCollapses.includes(collapse)) {
      this.setState({
        openedadvanceCollapses: [],
        advanceicon: "fas fa-plus-circle"
      });
    } else {
      this.setState({
        openedadvanceCollapses: [collapse],
        advanceicon: "fas fa-minus-circle"
      });
    }
  };

  handleInit() {
    //console.log("FilePond instance has initialised", this.pond);
  }
  onDismiss = () => { };
  toggleModalParameter = () => {
    this.setState({
      modalParameter: !this.state.modalParameter
    });
  };
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.getComputehours();
    let currentUrl = window.location.href;
    let continuePath = new URLSearchParams((currentUrl).substring(currentUrl.indexOf('?') + 1)).get('__o')
    if (continuePath === null) {
      continuePath = "/ "
    }
    this.state.pagehist = continuePath
    if (this.props.location.state !== undefined) {
      let mode = this.props.location.state.mode;
      Promise.all([this.GetAllClusters(), this.loadVmTypes()]).then(values => {
        const createcluster = [
          { label: <span className="df-btn-primary p-2" onClick={e => this.onOpenModal()} > <b style={{ color: 'white', cursor: 'pointer', fontSize: 14 }}> Create / Start a Cluster</b> </span> }
        ];

        if (this.state.vmTypes.length !== 0) {
          this.setState({
            clusteroptions: [...this.state.vmTypes, ...this.state.clusterTypes, ...createcluster]
          })
        } else {
          this.setState({
            clusteroptions: [...this.state.vmTypes, ...this.state.clusterTypes, ...createcluster]
          })
        }
        if (mode === "editProject") {
          this.EditProject(this.props.location.state.editId, this.props.location.state.editProject)
          this.state.projectName = this.props.location.state.editProject;
        }
        if (mode === "cloneProject") {
          this.CloneProject(this.props.location.state.cloneId, this.props.location.state.editId, this.props.location.state.editProject, this.props.location.state.from)
          this.state.projectName = this.props.location.state.editProject;
        }
        else if (mode === "runProject") {
          this.state.projectName = this.props.location.state.runName;
          this.RunProject(this.props.location.state.runPId)
        }
        else if (mode === "reRun") {
          this.LoadRerun(this.props.location.state.rerunId)
          ProjectService.GetProjectById(this.props.location.state.projectId).then((response) => {
            if (response.status === 'SUCCESS') {
              if (response.projectDTOS.length > 0) {
                let projectDTO = response.projectDTOS[0];
                this.setState({ projectName: projectDTO.name })
              }
            }
          })
        }
        else if (mode === "addnew") {
          this.NewRun_Init()
        }
      });
    }
    else {
      this.props.history.push("/project")
      window.location.reload(true);
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
  }
  NewRun_Init() {
    this.setState({
      // loading:true,
      btnActions: "Save",
      iconaction: "fas fa-save"
    });
  }

  getComputehours = () => {
    RunService.getRunComputeHours()
      .then((response) => {
        let consumedPercentage = response.consumedPercentage;
        if(consumedPercentage >= 100){
          this.setState({blockreRun: true})
        }
        else{
          this.setState({blockreRun: false})

        }
      })
    }



  closeProject = () => {
    if (this.state.pagehist === "/viewProject/") {
      let id = this.props.location.state.viewId
      let viewname = this.props.location.state.runName
      let chatMaster = this.props.location.state.chatmasterId
      let reg = "/viewProject";
      this.props.history.push({
        pathname: '/viewProject/' + id + "?__o=" + reg,
        state: { mode: "viewProject", viewId: id, viewname: viewname, chatmasterId: chatMaster }
      })
    }
    else {
      this.props.history.push({
        pathname: this.state.pagehist
      })
    }
  }

  GetAllClusters = () => {
    return ClusterService.getAllClusters()
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if(response.k8sDTOPage.content !== null){
          let clusterdetails = response.k8sDTOPage.content.filter(item => item.clusterStatus === "RUNNING")
          let modalclusterdetails = response.k8sDTOPage.content;
          this.renderClusterData(modalclusterdetails);

          this.setState({
            clusterK8sDTOS: clusterdetails
          }, () => {
            this.LoadAllClusters(this.state.clusterK8sDTOS)
          });
        }
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      })
  }


  LoadAllClusters = (options) => {
    if (options.length !== 0) {
      let tempOption = [];
      for (let a = 0; a < options.length; a++) {
        if (options[a].provisionerInfoDTO.provisionerType === "GOOGLE") {
          this.state.logotype = <img src={provisionerTypeLogo("GOOGLE")} style={{ width: '16px', height: '16px' }} alt="" ></img>
          this.state.badgestate = "bg-success"
        }else{
          if (options[a].provisionerInfoDTO.provisionerType === "AWS" || options[a].provisionerInfoDTO.provisionerType === "AMAZON") {
            this.state.logotype = <img src={provisionerTypeLogo("AWS")} style={{ width: '16px', height: '16px' }} alt="" ></img>
            this.state.badgestate = "bg-success"
          }
        }
        tempOption.push({
          label: <div><Badge color="" className="badge-dot"><i className={this.state.badgestate} /></Badge> {this.state.logotype} &nbsp;{options[a].name} </div>,
          value: options[a].name,
          computeType: 'CONTAINER',
          cloudType: '',
          id: options[a].id
        })
      }
      const clustOption = [...[{ label: 'Clusters', isDisabled: true }], ...tempOption]
      this.setState({
        clusterTypes: clustOption
      })
    }

  }

  loadVmTypes = () => {
    let machineTypes = [];
    // let vmOption = [ ];
    return ClusterService.getAllVirtualMachineType().then((res) => {
      if (res.status === "SUCCESS") {
        var machineTypeArray = res.virtualMachineTypeDTOs;
        for (const item of machineTypeArray) {
          machineTypes.push({
            label: <div>{item.name}&nbsp;&nbsp; <b><code>[CPU:</code>{item.vCPUs} &nbsp;&nbsp;<code>Memory:</code>{item.memory}<code>]</code></b></div>,
            value: item.name,
            id: item.id,
            computeType: 'VIRTUAL_MACHINE',
            cloudType: item.cloudType
          })
        }
        const vmOption = [...[{ label: 'Virtual Machines', isDisabled: true }], ...machineTypes]
        this.setState({
          vmTypes: vmOption
        })
      }
    })
  }


  renderClusterData(modalclusterdetails) {
    let datas = [];
    modalclusterdetails.map((item, index) => {
      datas.push({
        Id: item.id,
        ClusterName: <div className="namedisplay"> <span title={item.name} className="overflowStyle"><a href={() => false} className="text-primary" onClick={e => this.viewCluster(item.id)} ><b>{item.name}</b></a></span></div>,
        Description: <div className="namedisplay"><span title={item.description} className="overflowStyle">{item.description} </span></div>,
        Status: <div>
          {(item.clusterStatus === "PENDING" || item.clusterStatus === "CREATING" || item.clusterStatus === "DELETING" || item.clusterStatus === "STARTING" || item.clusterStatus === "RESTARTING") &&
            <Badge color="" className="badge-dot"><i className="bg-yellow blink" />{item.clusterStatus}</Badge>
          }
          {item.clusterStatus === "RUNNING" &&
            <Badge color="" className="badge-dot"><i className="bg-success" />{item.clusterStatus}</Badge>
          }
          {(item.clusterStatus === "STOPPING" || item.clusterStatus === "STOPPED") &&
            <Badge color="" className="badge-dot">{item.clusterStatus === "STOPPED" ? <i className="bg-darkgray" /> : <i className="bg-darkgray blink" />}{item.clusterStatus}</Badge>
          }

          {item.clusterStatus === "FAILED" && <div>
            <span className="actionicon" id={'uncon' + index}>
              <UncontrolledTooltip placement="top" target={'uncon' + index} delay={0}>
                {item.message}
              </UncontrolledTooltip>
              <i className="fas fa-exclamation-triangle" style={{ cursor: "pointer", color: "#ffcc00" }}></i><Badge color="" style={{ marginLeft: 10 }} className="badge-dot">{item.clusterStatus}</Badge>
            </span>
          </div>}

          {item.clusterStatus === "ERROR" &&
            <Badge color="" className="badge-dot"><i className="bg-red" />{item.clusterStatus}</Badge>
          }
        </div>,
        MonthlyUsage: 0,
        Cost: 0,
        Created: item.createdBy,
        Lastmodified: <div>{item.updatedDate !== null ? moment.utc(item.updatedDate).local().format('MMM DD, YYYY') : ""} <br></br>{item.updatedDate !== null ? moment.utc(item.updatedDate).local().format('hh:mm A') : ""}</div>,
        Actions: <Row>
          <span className="actionicon" id={'liveStatus' + index} onClick={e => {
            e.preventDefault()
            this.GetLiveStatus(item.id, item.name)
          }}><i className="fab fa-creative-commons-sampling mr-2" style={{ color: '#97c61b', cursor: 'pointer', fontSize: 18 }}><span style={{ paddingLeft: 7 }}>|</span></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <UncontrolledTooltip placement="top" target={'liveStatus' + index} delay={0}>
            Live Status
            </UncontrolledTooltip>
          <div className="row" style={(item.clusterStatus === "CREATING" || item.clusterStatus === "STARTING" || item.clusterStatus === "STOPPING" || item.clusterStatus === "DELETING" || item.clusterStatus === "RESTARTING") ? { pointerEvents: "none", opacity: 0.4 } : {}}>
            {/* {((this.state.startcluster === false) && (this.state.startindex === 'action'+index)) */}
            {(item.clusterStatus === "RUNNING")
              ?
              <div>
                <span className="actionicon" id={'action' + index} onClick={e => { this.StopCluster_Confirmation(item.id, e, item.name) }}><i className="fas fa-stop-circle mr-2 " style={{ color: 'red' }}></i> &nbsp;</span>
                <UncontrolledTooltip placement="bottom" target={'action' + index} delay={0}>
                  Stop
              </UncontrolledTooltip>
              </div>
              :
              <div style={item.clusterStatus === "ERROR" ? { pointerEvents: "none", opacity: 0.4 } : {}}>
                <span className="actionicon" id={'action' + index} onClick={e => { this.StartCluster(item.id, e) }}><i className="fas fa-play-circle mr-2" style={{ color: 'green' }}></i> &nbsp;</span>
                <UncontrolledTooltip placement="bottom" target={'action' + index} delay={0}>
                  Start
            </UncontrolledTooltip>
              </div>
            }
            <span style={item.clusterStatus === "RUNNING" ? {} : { pointerEvents: "none", opacity: 0.4 }} className="actionicon" id={'restart' + index} onClick={e => {
              e.preventDefault()
              this.RestartClusterConfirmation(item.id, item.name)
            }}><i className="fas fa-undo-alt mr-2" style={{ color: '#808080c7', cursor: 'pointer' }}></i> &nbsp;</span>
            <UncontrolledTooltip placement="bottom" target={'restart' + index} delay={0}>
              Restart
            </UncontrolledTooltip>
            <span className="actionicon" id={'clone' + index} onClick={e => {
              e.preventDefault()
              this.CloneClusterConfirmation(item.id, item.name)
            }}> <i className="far fa-clone text-red mr-2" style={{ color: '#007bff' }} /> &nbsp;</span>
            <UncontrolledTooltip placement="bottom" target={'clone' + index} delay={0}>
              Clone
            </UncontrolledTooltip>
            <span className="actionicon" id={'delete' + index} onClick={e => this.deleteCluster(item.id, item.name)}>
              <i className="fas fa-trash-alt text-red mr-2" style={{ color: '#007bff' }} /> &nbsp;</span>
          </div>
        </Row>
      })
    });

    this.setState({
      modalclusterdetails: datas,
    });

  }


  viewCluster = (id) => {
    this.props.history.push({
      pathname: '/cluster/viewcluster/' + id,
      state: { mode: "viewCluster", viewClusterId: id, }
    })
  }
  // Delete Cluster
  deleteCluster = (id, name) => {
    confirmAlert({
      title: <h5>Delete Cluster</h5>,
      message: 'Are you sure to delete this cluster? - ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.confirmDelete(id)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }

  StopCluster_Confirmation = (id, e, name) => {
    this.setState({ open: false })
    confirmAlert({
      title: <h5>Stop Cluster</h5>,
      message: 'Are you sure to stop this cluster? - ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.StopCluster(id, e)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }

  CloneClusterConfirmation = (id, name) => {
    this.setState({ open: false })

    confirmAlert({
      title: <h5>Clone Cluster</h5>,
      message: 'Are you sure to clone this cluster? - ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.CloneCluster(id)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }

  RestartClusterConfirmation = (id, name) => {
    this.setState({ open: false })

    confirmAlert({
      title: <h5>Restart Cluster</h5>,
      message: 'Are you sure to restart this cluster? - ' + name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.RestartCluster(id)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }

  confirmDelete(id) {
    ClusterService.deleteClusterById(id).then((response) => {
      if (response.status === 'SUCCESS') {
        // toast.success("Cluster Deleted Successfully!");
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }

  StartTerminateState(e, flag, index) {
    this.setState({
      actionstate: !flag,
      startindex: e.currentTarget.id
    })
    this.GetAllClusters();
  }
  // Start Cluster
  StartCluster = (id, e) => {
    let cid = e.currentTarget.id
    ClusterService.clusterStart(id).then((response) => {
      if (response.status === 'SUCCESS') {
        this.setState({
          startcluster: false,
          startindex: cid
        })
        this.GetAllClusters();
        // toast.success("Cluster Started Successfully!");

      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }

  // Stop Cluster
  StopCluster = (id, e) => {
    let cid = e.currentTarget.id
    ClusterService.clusterStop(id).then((response) => {
      if (response.status === 'SUCCESS') {
        this.setState({
          startcluster: true,
          startindex: cid
        })
        this.GetAllClusters();
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }
  // Clone Cluster
  CloneCluster = (cloneid) => {
    ClusterService.clusterClone(cloneid).then((response) => {
      if (response.status === 'SUCCESS') {
        // toast.success("Cluster Cloned Successfully!");
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }
  // Get live status update for current cluster
  GetLiveStatus = (statusId, name) => {
    ClusterService.clusterLiveStatus(statusId).then((response) => {
      if (response.status === 'SUCCESS') {
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }
  // Restart Cluster
  RestartCluster = (restartId) => {
    ClusterService.clusterRestart(restartId).then((response) => {
      if (response.status === 'SUCCESS') {
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }

  onOpenModal = () => {
    this.setState({
      open: true,
    })
  }

  onCloseModal = () => {
    this.setState({ open: false });
  };

  showHintForCluster = (cName) => {
    if (this.state.clusteroptions.length !== 0) {
      let filterTypeVmCluster = this.state.clusteroptions.filter(item => item.value === cName);
      if (filterTypeVmCluster.length === 0) {
        if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
          this.collapsesToggle("collapseFive");
        }
        let hintVmcluster = <span className="hintSize"><span className="df-text-danger font-weight-bold">"{cName}"</span> <span className="df-text-secondary">is not in the available list</span></span>
        this.setHintVmCluster(hintVmcluster);
        document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  showHintForRuntime = (kId, kName) =>{
    if (this.state.runTimeOptions.length !== 0) {
      let filterRuntime = this.state.runTimeOptions.filter(item => item.value === kId);
    if (filterRuntime.length === 0) {
      if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
        this.collapsesToggle("collapseFive");
      }
      let hintRunTime = <span className="hintSize"><span className="df-text-danger font-weight-bold">"{kName}"</span> <span className="df-text-secondary">is not in the available list</span></span>
      this.setHintRunTime(hintRunTime);
      document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
    }
    }
  }

  runtimeImageList = () => {
    if (this.state.clusterId !== null && this.state.clusterName !== null) {
      if (this.state.clusteroptions.length !== 0) {
        let getClusterData = this.state.clusteroptions.filter(item => item.value === this.state.clusterName);
        if (getClusterData.length !== 0) {
          let cloudTypelocal = getClusterData[0].cloudType;
          let computeTypelocal = getClusterData[0].computeType;
          Promise.all([this.getRunTimeImageName(cloudTypelocal, computeTypelocal)]).then(values => {
            this.showHintForCluster(this.state.clusterName)
            this.showHintForRuntime(this.state.kernelId, this.state.kernelName)
          })
        } else {
          this.showHintForCluster(this.state.clusterName)
        }
      }
    } else {
      // here cluster id and cluster name is null
      if (this.state.vmTypes.length > 1) {
        let getVMData = this.state.vmTypes[1];
        this.setState({
          hintVmCluster: "",
          clusterName: getVMData.value,
          computeType: getVMData.computeType === undefined || getVMData.computeType === null ? null : getVMData.computeType,
          cloudType: getVMData.cloudType === undefined || getVMData.cloudType === null ? null : getVMData.cloudType,
          clusterId: getVMData.id,
        }, () => {
          Promise.all([this.getRunTimeImageName(this.state.cloudType, this.state.computeType)]).then(values => {
            if (this.state.tags.length > 0) {
              let filterTags = this.state.tags.filter(item => item === "python" || item === "spark");
              if (filterTags.length !== 0 && this.state.runTimeOptions.length !== 0) {
                let runTimeData = this.state.runTimeOptions.filter(runtime =>  runtime.name.toLowerCase().includes(filterTags[0].toLowerCase()));
                if(runTimeData.length > 0){
                  this.setState({
                    kernelId: runTimeData[0].value,
                    kernelName: runTimeData[0].name,
                  })
                }
              } else {
                  this.setState({
                    kernelId: this.state.runTimeOptions[0].value,
                    kernelName: this.state.runTimeOptions[0].name,
                  })
              }
            }
          })
        })
      }
    }
  }

  LoadRerun(id) {
    this.setState({ loading: true, rerunId: id, btnActions: "Re-Run", iconaction: "fas fa-sync-alt" });
    this.state.rerunId = id
    RunService.GetRunById(id)
      .then((response) => {
        if (response.status === 'SUCCESS') {

          let parametersTables_array = []
          let parametersTables_files = response.runDTOS[0].parametersTables
          // if (response.runDTOS[0].parametersTables.length > 0) {
          if (parametersTables_files !== null) {
            for (let index = 0; index < parametersTables_files.length; index++) {
              parametersTables_array.push(parametersTables_files[index])
            }
            this.setState({
              parametersTablesdata: parametersTables_array
            });
          }
          else {
            this.setState({
              parametersTablesdata: []
            });
          }
          this.setState({
            rname: response.runDTOS[0].name,
            description: response.runDTOS[0].description,
            clusterName: response.runDTOS[0].clusterName,
            clusterId: response.runDTOS[0].clusterId,
            kernelName: response.runDTOS[0].kernelName,
            kernelId: response.runDTOS[0].kernelId,
            computeType: response.runDTOS[0].computeType,
            masterJobId: response.runDTOS[0].masterJobId,
            delimiter: response.runDTOS[0].outputFileDelimiter,
            hideCodeCells:response.runDTOS[0].hideCodeCells,
            setFiles_input: response.runDTOS[0].modelInputFiles || [],
            setFolders_input: response.runDTOS[0].modelInputFolders || [],
            setFiles_code: response.runDTOS[0].modelCodeFiles || [],
            setFolders_code: response.runDTOS[0].modelCodeFolders || [],
            recentUploadpassInput: response.runDTOS[0].recentInputRunDTO == null ? [] : response.runDTOS[0].recentInputRunDTO,
            recentUploadpassCode: response.runDTOS[0].recentCodeRunDTO == null ? [] : response.runDTOS[0].recentCodeRunDTO,
            recentFilesInput: response.runDTOS[0].recentInputRunDTO == null ? [] : response.runDTOS[0].recentInputRunDTO.modelFiles,
            recentFilesCode: response.runDTOS[0].recentCodeRunDTO == null ? [] : response.runDTOS[0].recentCodeRunDTO.modelFiles,
            parameterSet: response.runDTOS[0].parameterSet,
            tags: response.runDTOS[0].tags === null ? [] : response.runDTOS[0].tags,
            parametersTables: response.runDTOS[0].parametersTables === null ? parametersTables_array : [],
            loading: false,
            inputCodeFilesRequired: response.runDTOS[0].inputCodeFilesRequired == null ? false : response.runDTOS[0].inputCodeFilesRequired,
            inputFilesRequired: response.runDTOS[0].inputFilesRequired == null ? false : response.runDTOS[0].inputFilesRequired,
            rerunFromSavedInputFiles: response.runDTOS[0].rerunFromSavedInputFiles == null ? false : response.runDTOS[0].rerunFromSavedInputFiles,
            rerunFromSavedCodeFiles: response.runDTOS[0].rerunFromSavedCodeFiles == null ? false : response.runDTOS[0].rerunFromSavedCodeFiles,

          }, () => {
            this.runtimeImageList(); // here load load runtime data based on cloud and compute type
          })
          this.ConstructParameterTable(parametersTables_array)
          this.state.parameterSet = response.runDTOS[0].parameterSet;
          document.getElementById("textAreaPythonParam").value = response.runDTOS[0].libraries;
          this.splitTreeView(this.state.recentFilesInput, this.state.recentFilesCode);
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  // Run project
  RunProject(id) {
    this.setState({
      loading: true,
      btnActions: "Run",
      runPId: id,
      iconaction: "fas fa-running"
    });
    ProjectService.GetProjectById(id)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let parametersTables_array = []
          let parametersTables_files = response.projectDTOS[0].parametersTables
          if (response.projectDTOS[0].parametersTables.length > 0) {
            for (let index = 0; index < parametersTables_files.length; index++) {
              parametersTables_array.push(parametersTables_files[index])
            }
            this.setState({
              parametersTablesdata: parametersTables_array
            });
          }
          else {
            this.setState({
              parametersTablesdata: []
            });
          }

          this.setState({
            rname: response.projectDTOS[0].name,
            description: response.projectDTOS[0].description,
            clusterName: response.projectDTOS[0].clusterName,
            clusterId: response.projectDTOS[0].clusterId,
            kernelName: response.projectDTOS[0].kernelName,
            kernelId: response.projectDTOS[0].kernelId,
            computeType: response.projectDTOS[0].computeType,
            setFiles_input: response.projectDTOS[0].modelInputFiles || [],
            setFolders_input: response.projectDTOS[0].modelInputFolders || [],
            setFiles_code: response.projectDTOS[0].modelCodeFiles || [],
            setFolders_code: response.projectDTOS[0].modelCodeFolders || [],
            runDBId: response.projectDTOS[0].id,
            runId: response.projectDTOS[0].id,
            delimiter: response.projectDTOS[0].outputFileDelimiter,
            tags: response.projectDTOS[0].tags == null ? [] : response.projectDTOS[0].tags,
            loading: false,
            inputCodeFilesRequired: response.projectDTOS[0].inputCodeFilesRequired,
            inputFilesRequired: response.projectDTOS[0].inputFilesRequired,
            rerunFromSavedInputFiles: response.projectDTOS[0].rerunFromSavedInputFiles,
            rerunFromSavedCodeFiles: response.projectDTOS[0].rerunFromSavedCodeFiles,
            parameterSet: response.projectDTOS[0].parameterSet,
            parametersTables: response.projectDTOS[0].parametersTables.length > 0 ? parametersTables_array : [],
            hideCodeCells:response.projectDTOS[0].hideCodeCells,

          }, () => {
            this.runtimeImageList(); // here load load runtime data based on cloud and compute type
          })
          this.ConstructParameterTable(parametersTables_array)
          document.getElementById("textAreaPythonParam").value = response.projectDTOS[0].libraries;
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }

  // Load edit project
  EditProject(id, editProject) {
    this.setState({
      loading: true,
      btnActions: "Update",
      editId: id,
      iconaction: "fas fa-edit",
    });
    ProjectService.GetProjectById(id)
      .then((response) => {
        //  console.log(JSON.stringify(response))
        if (response.status === 'SUCCESS') {
          let parametersTables_array = []
          let parametersTables_files = response.projectDTOS[0].parametersTables
          if (response.projectDTOS[0].parametersTables.length > 0) {
            for (let index = 0; index < parametersTables_files.length; index++) {
              parametersTables_array.push(parametersTables_files[index])
            }
            this.setState({
              parametersTablesdata: parametersTables_array
            });
          }
          else {
            this.setState({
              parametersTablesdata: []
            });
          }
          this.setState({
            rname: response.projectDTOS[0].name,
            description: response.projectDTOS[0].description,
            clusterName: response.projectDTOS[0].clusterName,
            clusterId: response.projectDTOS[0].clusterId,
            computeType: response.projectDTOS[0].computeType,
            kernelName: response.projectDTOS[0].kernelName,
            kernelId: response.projectDTOS[0].kernelId,
            setFiles_input: response.projectDTOS[0].modelInputFiles || [],
            setFolders_input: response.projectDTOS[0].modelInputFolders || [],
            setFiles_code: response.projectDTOS[0].modelCodeFiles || [],
            setFolders_code: response.projectDTOS[0].modelCodeFolders || [],
            runDBId: response.projectDTOS[0].id,
            runId: response.projectDTOS[0].id,
            delimiter: response.projectDTOS[0].outputFileDelimiter,
            tags: response.projectDTOS[0].tags == null ? [] : response.projectDTOS[0].tags,
            loading: false,
            inputCodeFilesRequired: response.projectDTOS[0].inputCodeFilesRequired == null ? false : response.projectDTOS[0].inputCodeFilesRequired,
            inputFilesRequired: response.projectDTOS[0].inputFilesRequired == null ? false : response.projectDTOS[0].inputFilesRequired,
            rerunFromSavedInputFiles: response.projectDTOS[0].rerunFromSavedInputFiles == null ? false : response.projectDTOS[0].rerunFromSavedInputFiles,
            rerunFromSavedCodeFiles: response.projectDTOS[0].rerunFromSavedCodeFiles == null ? false : response.projectDTOS[0].rerunFromSavedCodeFiles,
            parameterSet: response.projectDTOS[0].parameterSet,
            parametersTables: response.projectDTOS[0].parametersTables.length > 0 ? parametersTables_array : [],
            hideCodeCells:response.projectDTOS[0].hideCodeCells,

          }, () => {
            this.runtimeImageList(); // here load load runtime data based on cloud and compute type
          })
          this.ConstructParameterTable(parametersTables_array)
          document.getElementById("textAreaPythonParam").value = response.projectDTOS[0].libraries;
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  // Load Clone project
  CloneProject(cid, id, editProject, from) {
    this.setState({
      loading: true,
      btnActions: "Clone",
      editId: id,
      iconaction: "far fa-clone",
    });
    if (from === "project") {
      ProjectService.GetProjectById(id)
        .then((response) => {
          if (response.status === 'SUCCESS') {
            let parametersTables_array = []
            let parametersTables_files = response.projectDTOS[0].parametersTables
            if (response.projectDTOS[0].parametersTables.length > 0) {
              for (let index = 0; index < parametersTables_files.length; index++) {
                parametersTables_array.push(parametersTables_files[index])
              }
              this.setState({
                parametersTablesdata: parametersTables_array
              });
            }
            else {
              this.setState({
                parametersTablesdata: []
              });
            }
            this.setState({
              rname: response.projectDTOS[0].name,
              description: response.projectDTOS[0].description,
              clusterName: response.projectDTOS[0].clusterName,
              clusterId: response.projectDTOS[0].clusterId,
              kernelName: response.projectDTOS[0].kernelName,
              computeType: response.projectDTOS[0].computeType,
              kernelId: response.projectDTOS[0].kernelId,
              setFiles_input: response.projectDTOS[0].modelInputFiles || [],
              setFolders_input: response.projectDTOS[0].modelInputFolders || [],
              setFiles_code: response.projectDTOS[0].modelCodeFiles || [],
              setFolders_code: response.projectDTOS[0].modelCodeFolders || [],
              runDBId: response.projectDTOS[0].id,
              runId: response.projectDTOS[0].id,
              delimiter: response.projectDTOS[0].outputFileDelimiter,
              tags: response.projectDTOS[0].tags == null ? [] : response.projectDTOS[0].tags,
              loading: false,
              inputCodeFilesRequired: response.projectDTOS[0].inputCodeFilesRequired == null ? false : response.projectDTOS[0].inputCodeFilesRequired,
              inputFilesRequired: response.projectDTOS[0].inputFilesRequired == null ? false : response.projectDTOS[0].inputFilesRequired,
              rerunFromSavedInputFiles: response.projectDTOS[0].rerunFromSavedInputFiles == null ? false : response.projectDTOS[0].rerunFromSavedInputFiles,
              rerunFromSavedCodeFiles: response.projectDTOS[0].rerunFromSavedCodeFiles == null ? false : response.projectDTOS[0].rerunFromSavedCodeFiles,
              //  parameterSet: response.projectDTOS[0].parameterSet,
              parametersTables: response.projectDTOS[0].parametersTables.length > 0 ? parametersTables_array : [],
              hideCodeCells:response.projectDTOS[0].hideCodeCells,

            }, () => {
              this.runtimeImageList(); // here load load runtime data based on cloud and compute type
            })
            this.ConstructParameterTable(parametersTables_array)
            document.getElementById("textAreaPythonParam").value = response.projectDTOS[0].libraries;
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
        });
    }
    if (from === "runs") {

      RunService.GetRunById(cid)
        .then((response) => {
          if (response.status === 'SUCCESS') {

            let parametersTables_array = []
            let parametersTables_files = response.runDTOS[0].parametersTables
            if (parametersTables_files !== null) {
              for (let index = 0; index < parametersTables_files.length; index++) {
                parametersTables_array.push(parametersTables_files[index])
              }
              this.setState({
                parametersTablesdata: parametersTables_array
              });
            }
            else {
              this.setState({
                parametersTablesdata: []
              });
            }
            this.setState({
              rname: response.runDTOS[0].name,
              description: response.runDTOS[0].description,
              clusterName: response.runDTOS[0].clusterName,
              clusterId: response.runDTOS[0].clusterId,
              kernelName: response.runDTOS[0].kernelName,
              kernelId: response.runDTOS[0].kernelId,
              computeType: response.runDTOS[0].computeType,
              masterJobId: response.runDTOS[0].masterJobId,
              delimiter: response.runDTOS[0].outputFileDelimiter,
              setFiles_input: response.runDTOS[0].modelInputFiles || [],
              setFolders_input: response.runDTOS[0].modelInputFolders || [],
              setFiles_code: response.runDTOS[0].modelCodeFiles || [],
              setFolders_code: response.runDTOS[0].modelCodeFolders || [],
              recentUploadpassInput: response.runDTOS[0].recentInputRunDTO == null ? [] : response.runDTOS[0].recentInputRunDTO,
              recentUploadpassCode: response.runDTOS[0].recentCodeRunDTO == null ? [] : response.runDTOS[0].recentCodeRunDTO,
              recentFilesInput: response.runDTOS[0].recentInputRunDTO == null ? [] : response.runDTOS[0].recentInputRunDTO.modelFiles,
              recentFilesCode: response.runDTOS[0].recentCodeRunDTO == null ? [] : response.runDTOS[0].recentCodeRunDTO.modelFiles,
              parameterSet: response.runDTOS[0].parameterSet,
              tags: response.runDTOS[0].tags === null ? [] : response.runDTOS[0].tags,
              parametersTables: response.runDTOS[0].parametersTables === null ? parametersTables_array : [],
              loading: false,
              inputCodeFilesRequired: response.runDTOS[0].inputCodeFilesRequired == null ? false : response.runDTOS[0].inputCodeFilesRequired,
              inputFilesRequired: response.runDTOS[0].inputFilesRequired == null ? false : response.runDTOS[0].inputFilesRequired,
              rerunFromSavedInputFiles: response.runDTOS[0].rerunFromSavedInputFiles == null ? false : response.runDTOS[0].rerunFromSavedInputFiles,
              rerunFromSavedCodeFiles: response.runDTOS[0].rerunFromSavedCodeFiles == null ? false : response.runDTOS[0].rerunFromSavedCodeFiles,
              hideCodeCells:response.runDTOS[0].hideCodeCells,


            }, () => {
              this.runtimeImageList(); // here load load runtime data based on cloud and compute type   
            })
            this.ConstructParameterTable(parametersTables_array)
            this.state.parameterSet = response.runDTOS[0].parameterSet;
            document.getElementById("textAreaPythonParam").value = response.runDTOS[0].libraries;
            this.splitTreeView(this.state.recentFilesInput, this.state.recentFilesCode);
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
        });
    }

  }
  // Handling remove job actions
  RemoveAction = (rid) => {
    let RemoveJobdto = {
      id: rid
    }
    RunService.removeJob(RemoveJobdto)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          this.props.history.push('/runs');
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }

  setHintVmCluster = (hint) => {
    this.setState({
      hintVmCluster: hint
    })
  }

  setHintRunTime = (hint) => {
    this.setState({
      hintRunTime: hint
    })
  }

  setHintName = (hint) => {
    this.setState({
      hintName: hint
    })
  }

  setHintCodeFiles = (hint) => {
    this.setState({
      hintCodeFiles: hint
    })
  }

  clearErrorHintMessage = () => {
    this.setState({
      hintRunTime: "",
      hintVmCluster: "",
      hintCodeFiles: "",
      hintName: ""
    })
  }

  handleChangeSelect = (event) => {
    if (event !== undefined) {
      let cloudType = event.cloudType
      let computeType = event.computeType
      this.setState({
        hintVmCluster: "",
        clusterName: event.value,
        computeType: event.computeType,
        clusterId: event.id,
        clusterLable: event.label,
      })
      if(this.state.kernelId !== null && this.state.kernelName !== ""){
        Promise.all([this.getRunTimeImageName(cloudType, computeType)]).then(values => {
          this.showHintForRuntime(this.state.kernelId, this.state.kernelName)
        })
      }else{
        this.getRunTimeImageName(cloudType, computeType)
      }
    }
  }
  getRunTimeImageName = (cloudType, imageType) => {
    var imagesName = [];
    return ImageService.getCloudImagesByType(cloudType, imageType).then((res) => {
      if (res.status === "SUCCESS") {
        var imgNameArray = res.cloudImagesDTOPage.content;
        for (let item of imgNameArray) {
          let imageName = " ";
          if (item.name.includes('Python')) {
            imageName = "PYTHON"
          }
          if (item.name.includes('Spark')) {
            imageName = "SPARK"
          }
          imagesName.push({
            label: <div><img className="" src={provisionerTypeLogo(imageName)} alt="" />&nbsp; {item.name}</div>,
            value: item.id,
            id: item.id,
            name: item.name,
            imageId: item.imageId,
            // kernelName: item.name
          })
        }
        if(this.props.location.state.mode === "addnew"){
          if(imagesName.length > 0){
            this.setState({
              kernelId : imagesName[0].value,
              kernelName : imagesName[0].name,
              runTimeOptions: imagesName
            })
          }
        }else{
          this.setState({
            runTimeOptions: imagesName
          })
        }
        
      }
    })
  }
  handleChangeSelectKernel = (event) => {
    this.setState({
      hintRunTime: "",
      kernelId: event.value,
      kernelName: event.name
    })



    // if(this.state.runTimeOptions.length !==0){
    //   let getRowImage  = this.state.runTimeOptions.filter(item=>item.value === event.value)
    //   this.setState({
    //     kernelId: getRowImage[0].value,
    //     kernelName:getRowImage[0].name,       
    //   });
    // }
  }
  handleChangeSelectDelimiter = (event) => {
    if (event === undefined) {
      this.setState({
        delimiter: ","
      });
    } else {
      this.setState({
        delimiter: event.value
      });
    }
  }
  handleSaveInputFile = (event) => {
    this.setState({
      inputFilesRequired: event.target.checked
    })
    if (event.target.checked === false) {
      this.setState({
        rerunFromSavedInputFiles: false
      })
    }
  }
  handleRerunSaveInputFile = (event) => {
    this.setState({
      rerunFromSavedInputFiles: event.target.checked
    })
  }
  handleSaveInputCode = (event) => {
    this.setState({
      inputCodeFilesRequired: event.target.checked
    })
    if (event.target.checked === false) {
      this.setState({
        rerunFromSavedCodeFiles: false
      })
    }
  }
  handleRerunSaveInputFileCode = (event) => {
    this.setState({
      rerunFromSavedCodeFiles: event.target.checked
    })
  }
  handleHideModelCell = (event) => {
    this.setState({
      hideCodeCells: event.target.checked
    })
  }
  handleChangeInput = (event) => {
    this.setState({
      checkboxStateInput: event.target.checked
    })
  }
  handleChangeCode = (event) => {
    this.setState({
      checkboxStateCode: event.target.checked
    })
  }
  // handling event changes email,password
  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    if (name === "rname") {
      this.setState({
        hintName: ""
      })
    }
    this.setState({ [name]: value });
  }
  addChip = (value) => {
    this.setState({ tags: [...this.state.tags, value] })
    // this.CreateTags(id,tags);
  };
  getColor = () => {
    let colorCode = getRandomRolor();
    return colorCode;
  }
  checkCollapseOpenorNot = (collapseValue) => {
    let openCollapse = this.state.openedCollapses.filter(item => item === collapseValue)
    if (openCollapse.length > 0) {
      return false
    } else {
      return true;
    }
  }
  removeChip = (index) => {
    this.state.tags.splice(index, 1)
    this.setState({ tags: this.state.tags })
    // this.CreateTags(id,getData[0].Tags);
  };
  // Submit runs Data
  SubmitProject = (event) => {
    event.preventDefault();
    this.setState({ rerunFromSavedInputFiles: false, rerunFromSavedCodeFiles: false });
    if (this.state.inputFilesRequired === false) {
      this.setState({ rerunFromSavedInputFiles: false });
    }
    else {
      this.setState({ rerunFromSavedInputFiles: true });
    }
    if (this.state.inputCodeFilesRequired === false) {
      this.setState({ rerunFromSavedCodeFiles: false });
    }
    else {
      this.setState({ rerunFromSavedCodeFiles: true });
    }
    if (this.state.rname === "" || this.state.rname === undefined) {
      let hintName = <span className="hintSize"><span className="df-text-danger font-weight-light">Please Enter run name</span></span>
      document.getElementsByName('rname')[0].focus()
      this.setHintName(hintName);
    }
    else if (this.state.setFiles_code.length === 0) {
      document.getElementById('inputcodefiles').focus()
      this.collapsesToggle("collapseTwo");
      let hintCode = <span className="hintSize"><span className="df-text-danger font-weight-light">Please upload atleast one file in code</span></span>
      this.setHintCodeFiles(hintCode);
    }
    else if (this.state.clusterName === "" || this.state.clusterName === null || this.state.clusterName === undefined ||
    this.state.clusterId === "" || this.state.clusterId === null || this.state.clusterId === undefined) {
      if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
        this.collapsesToggle("collapseFive");
      }
      let hintVmcluster = <span className="hintSize"><span className="df-text-danger font-weight-light">Please Select a Machine Type / Cluster</span></span>
      this.setHintVmCluster(hintVmcluster)
      document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
    }
    else if (this.state.kernelName === "" || this.state.kernelName === null || this.state.kernelName === undefined) {
      if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
        this.collapsesToggle("collapseFive");
      }
      let hintRT = <span className="hintSize"><span className="df-text-danger font-weight-light">Please Select Runtime</span></span>
      this.setHintRunTime(hintRT);
      document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
    }

    else if (this.state.computeType === "" || this.state.computeType === null || this.state.computeType === undefined) {
      if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
        this.collapsesToggle("collapseFive");
      }
      let hintVmcluster = <span className="hintSize"><span className="df-text-danger font-weight-light">Please Select a Machine Type / Cluster</span></span>
      this.setHintVmCluster(hintVmcluster);
      document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
    }
    else if (this.state.hintVmCluster !== "") {
      if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
        this.collapsesToggle("collapseFive");
      }
      document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
    }
    else if (this.state.hintRunTime !== "") {
      if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
        this.collapsesToggle("collapseFive");
      }
      document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
    }
    else {
      this.clearErrorHintMessage();
      let post = {
        clusterName: this.state.clusterName,
        kernelName: this.state.kernelName,
        kernelId: (this.state.kernelId === "" ||
          this.state.kernelId === null ||
          this.state.kernelId === undefined) ? null : this.state.kernelId,
        description: this.state.description,
        id: this.state.runDBId,
        computeType: this.state.computeType,
        clusterId: ((this.state.clusterId === undefined ||
          this.state.clusterId === "undefined" ||
          this.state.clusterId === null ||
          this.state.clusterId === "") ? null : this.state.clusterId),
        // machineId: ((this.state.machineId == undefined || this.state.machineId == "undefined") ? null : this.state.machineId),
        masterJobId: this.state.masterJobId,
        outputFileDelimiter: this.state.delimiter,
        modelCodeFiles: this.state.setFiles_code,
        modelCodeFolders: this.state.setFolders_code,
        modelInputFiles: this.state.setFiles_input,
        modelInputFolders: this.state.setFolders_input,
        recentInputRunDTO: this.state.checkboxStateInput ? this.state.recentUploadpassInput : null,
        recentCodeRunDTO: this.state.checkboxStateCode ? this.state.recentUploadpassCode : null,
        name: this.state.rname,
        inputCodeFilesRequired: this.state.inputCodeFilesRequired,
        inputFilesRequired: this.state.inputFilesRequired,
        rerunFromSavedInputFiles: this.state.rerunFromSavedInputFiles,
        rerunFromSavedCodeFiles: this.state.rerunFromSavedCodeFiles,
        parameterSet: this.state.parameterSet,
        // parametersTables:this.state.parameterSet,
        tags: this.state.tags,
        libraries: document.getElementById("textAreaPythonParam").value,
        hideCodeCells:this.state.hideCodeCells,
      }
      this.setState({ loading: true });
      if (this.state.btnActions === "Update") {
        this.ToCallupdateService(post, this.state.editId)
      }
      if (this.state.btnActions === "Clone") {
        this.ToCallnewProject(post);
      }
      if (this.state.btnActions === "Run") {
        var newKey = "masterJobId";
        var newVal = this.state.runPId;
        post[newKey] = newVal;
        this.ToCallrunService(post, this.state.runPId, 'run',)
      } else if (this.state.btnActions === "Re-Run") {
        this.ToCallrunService(post, this.state.masterJobId, 'rerun')
        //masterJobId only going..
      }
      if (this.state.btnActions === "Save") {
        this.ToCallnewProject(post);
      }
    }
  }


  /**
   * 
   * @param {scheduler data} scheduleDo 
   * @param {update or create} type 
   */

  SubmitScheduleProject = (scheduleDo, type) => {
    //event.preventDefault();
    this.setState({
      rerunFromSavedInputFiles: false,
      rerunFromSavedCodeFiles: false,
    });
    if (this.state.inputFilesRequired === false) {
      this.setState({ rerunFromSavedInputFiles: false });
    } else {
      this.setState({ rerunFromSavedInputFiles: true });
    }
    if (this.state.inputCodeFilesRequired === false) {
      this.setState({ rerunFromSavedCodeFiles: false });
    } else {
      this.setState({ rerunFromSavedCodeFiles: true });
    }
    if (this.state.rname === "" || this.state.rname === undefined) {
      let hintName = <span className="hintSize"><span className="df-text-danger font-weight-light">Please Enter run name</span></span>
      this.setHintName(hintName);
      document.getElementsByName('rname')[0].focus()
    }
    else if (this.state.setFiles_code.length === 0) {
      this.collapsesToggle("collapseTwo");
      let hintCode = <span className="hintSize"><span className="df-text-danger font-weight-light">Please upload atleast one file in code</span></span>
      this.setHintCodeFiles(hintCode);
      document.getElementById('inputcodefiles').focus()
    }
    else if (this.state.clusterName === "" || this.state.clusterName === null || this.state.clusterName === undefined) {
      if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
        this.collapsesToggle("collapseFive");
      }
      let hintVmcluster = <span className="hintSize"><span className="df-text-danger font-weight-light">Please Select a Machine Type / Cluster</span></span>
      this.setHintVmCluster(hintVmcluster);
      document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
    }
    else if (this.state.kernelName === "" || this.state.kernelName === null || this.state.kernelName === undefined) {
      if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
        this.collapsesToggle("collapseFive");
      }
      let hintRT = <span className="hintSize"><span className="df-text-danger font-weight-light">Please Select Runtime</span></span>
      this.setHintRunTime(hintRT);
      document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
    }

    else if (this.state.computeType === "" || this.state.computeType === null || this.state.computeType === undefined) {
      if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
        this.collapsesToggle("collapseFive");
      }
      let hintVmcluster = <span className="hintSize"><span className="df-text-danger font-weight-light">Please Select a Machine Type / Cluster</span></span>
      this.setHintVmCluster(hintVmcluster);
      document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
    }
    else if (this.state.hintVmCluster !== "") {
      if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
        this.collapsesToggle("collapseFive");
      }
      document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
    }
    else if (this.state.hintRunTime !== "") {
      if (this.checkCollapseOpenorNot("collapseFive")) { // check if already open just focus the tab
        this.collapsesToggle("collapseFive");
        document.getElementById('clusterName').scrollIntoView({ behavior: 'smooth' })
      }
    } else {
      this.clearErrorHintMessage();
      let post = {
        clusterName: this.state.clusterName,
        kernelName: this.state.kernelName,
        kernelId: (this.state.kernelId === "" ||
          this.state.kernelId === null ||
          this.state.kernelId === undefined) ? null : this.state.kernelId,
        description: this.state.description,
        id: this.state.runDBId,
        clusterId: ((this.state.clusterId === undefined ||
          this.state.clusterId === "undefined" ||
          this.state.clusterId === null ||
          this.state.clusterId === "") ? null : this.state.clusterId),
        // machineId: ((this.state.machineId == undefined || this.state.machineId == "undefined") ? null : this.state.machineId),
        computeType: this.state.computeType,
        masterJobId: this.state.masterJobId,
        outputFileDelimiter: this.state.delimiter,
        modelCodeFiles: this.state.setFiles_code,
        modelCodeFolders: this.state.setFolders_code,
        modelInputFiles: this.state.setFiles_input,
        modelInputFolders: this.state.setFolders_input,
        recentInputRunDTO: this.state.checkboxStateInput
          ? this.state.recentUploadpassInput
          : null,
        recentCodeRunDTO: this.state.checkboxStateCode
          ? this.state.recentUploadpassCode
          : null,
        name: this.state.rname,
        inputCodeFilesRequired: this.state.inputCodeFilesRequired,
        inputFilesRequired: this.state.inputFilesRequired,
        rerunFromSavedInputFiles: this.state.rerunFromSavedInputFiles,
        rerunFromSavedCodeFiles: this.state.rerunFromSavedCodeFiles,
        parameterSet: this.state.parameterSet,
        // parametersTables:this.state.parameterSet,
        tags: this.state.tags,
        libraries: document.getElementById("textAreaPythonParam").value,
        scheduledRun: true,
        schedulerDTO: scheduleDo,
        hideCodeCells:this.state.hideCodeCells,

      };
      this.setState({ loading: true });
      if (this.state.btnActions === "Update") {
        this.ToCallupdateService(post, this.state.editId);
      }
      if (this.state.btnActions === "Clone") {
        this.ToCallnewProject(post);
      }
      if (this.state.btnActions === "Run") {
        var newKey = "masterJobId";
        var newVal = this.state.runPId;
        post[newKey] = newVal;
        this.ToCallrunService(post, this.state.runPId, "run");
      } else if (this.state.btnActions === "Re-Run") {
        this.ToCallrunService(post, this.state.masterJobId, "rerun");
        //masterJobId only going..
      }
      if (this.state.btnActions === "Save") {
        this.ToCallnewProject(post);
      }
    }
  };

  //to call service run project here
  ToCallrunService = (post, id, from) => {
    RunService.PostRerun(post, this.state.rerunId, from).then((response) => {
      if (response.status === "SUCCESS") {
        toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">New Job created Successfully!</b></i>); 
        let runsData = response.runDTOS[0];
        if (runsData.scheduleId !== null && runsData.scheduleId !== undefined) {
          this.props.history.push("/schedule?id=" + runsData.scheduleId + "&scheduleFor=runs")
        } else {
          this.props.history.push({
            pathname: "/viewProject/" + id,
            state: { viewId: id },
          });
        }

        this.setState({ loading: false });
      } else {
        this.setState({ loading: false });
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  };

  //to call service update project here
  ToCallupdateService = (post, id) => {
    ProjectService.Updateproject(post, id)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Project Updated Successfully!</b></i>); 
          this.props.history.push('/project');
          this.setState({ loading: false });
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
          this.setState({ loading: false }); 
        }
      });
  }
  //to call service create project here
  ToCallnewProject = (post) => {
    ProjectService.NewProject(post)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if (this.state.btnActions === "Save") {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Project Posted Successfully!</b></i>); 
          }
          if (this.state.btnActions === "Clone") {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Project Cloned Successfully!</b></i>); 
          }

          this.props.history.push('/project');
          this.setState({ loading: false });
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          this.setState({ loading: false });
        }
      });
  }

  splitTreeView = (inputArray, codeArray) => {
    let finalarray_input = [];
    let finalarray_code = [];

    inputArray.map(item => {
      let rest = item.substring(0, item.lastIndexOf("/") + 1);
      let last = item.substring(item.lastIndexOf("/") + 1, item.length);
      finalarray_input.push({
        folder: rest,
        file: last
      })
    })
    codeArray.map(item2 => {
      let rest = item2.substring(0, item2.lastIndexOf("/") + 1);
      let last = item2.substring(item2.lastIndexOf("/") + 1, item2.length);
      finalarray_code.push({
        folder: rest,
        file: last
      })
    })
    this.setState({
      recentInputfolders: finalarray_input,
      recentCodefolders: finalarray_code
    })
  }

  removeAll(type) {
    if (type === "input") {
      this.setState({ setFiles_input: [], setFolders_input: [] })
    } else {
      this.setState({ setFiles_code: [], setFolders_code: [] })
    }
  }

  // remove files in array 
  RemoveFiles(wholeArray, file, type, isFolder) {
    let setFiles = ''

    if (type === "input") {
      setFiles = isFolder ? 'setFolders_input' : 'setFiles_input'
    } else {
      setFiles = isFolder ? 'setFolders_code' : 'setFiles_code'
    }
    const j = wholeArray.findIndex(item => item === file);
    // console.log('Folder Found', j)
    if (j > -1) {
      wholeArray.splice(j, 1);
      let _state = {}
      _state[setFiles] = wholeArray
      this.setState(_state)
    }
    // this.setState({
    //   setFiles_input: wholeArray
    // });
  }

  // Reset form data
  clearformData() {
    this.setState({
      rname: "",
      description: "",
      clusterName: '',
      clusterId: null,
      kernelName: ''
    })
  }

  handleInputfiles = (files) => {
    this.setState({
      files_input: files
    });
  }

  handlecodefiles = (files) => {
    this.setState({
      files_code: files
    });
  }

  FilesResponse(data, type) {
    if (type === "input") {
      data.map((item, index) => {
        this.setState({
          setFiles_input: [...this.state.setFiles_input, item.fileName],
          files_input: [],
          loading: false
        });
      });
    } else {
      data.map((item, index) => {
        this.setState({
          setFiles_code: [...this.state.setFiles_code, item.fileName],
          files_code: [],
          loading: false
        });
      });
    }
  }

  toggleAddStorageItem = () => {
    if (this.state.showAddStorageModal) {
      this.setState({ showAddStorageModal: false })
    } else {
      this.setState({ showAddStorageModal: true })
      this.fetchStorageItems()
      let { storageFilesToBeAdded, storageFoldersToBeAdded } = this.getStorageFiles()
      this.setState({ storageFilesToBeAdded: [...storageFilesToBeAdded], storageFoldersToBeAdded: [...storageFoldersToBeAdded] })
      this.setSelectAllFilesIcon(storageFilesToBeAdded, storageFoldersToBeAdded)
    }
  }

  toggleUpload = () => {
    if (this.state.showUploadModal) {
      this.setState({ showUploadModal: false })
    } else {
      this.setState({ showUploadModal: true })
    }
  }

  _fetchStorageItems = (prefix, pageToken, files, folders) => {
    // Needs to remove while support additional mount
    StorageService.listObjects(prefix, null, null, pageToken)
      .then((response) => {
        files = [...files, ...response.result]
        folders = [...folders, ...response.prefixes]
        if (response.next_page_token) {
          this.state.nextPageToken = response.next_page_token
        } else {
          this.state.nextPageToken = null
        }
        // if (!response.next_page_token) {
        this.setState({ currFolder: prefix })
        this.setState({ storageFiles: files })
        this.setState({ storageFolders: folders })
        this.constructNavigation()
        // } else {
        //   this._fetchStorageItems(prefix, response.next_page_token, files, folders)
        // }
      })
  }

  fetchStorageItems = (prefix, pageToken) => {
    this.setState({
      storageFiles: [],
      storageFolders: [],
      nextPageToken: null
    })
    this._fetchStorageItems(prefix, pageToken, [], [])
  }

  selectAllFilesClick = () => {
    let storageFilesToBeAdded = [...this.state.storageFilesToBeAdded]
    let storageFoldersToBeAdded = [...this.state.storageFoldersToBeAdded]
    if (this.state.selectAllFiles) {
      this.setState({ selectAllFiles: false })
      this.setState({ selectAllFilesClass: "far fa-square pr-2" })
      for (let storageFile of this.state.storageFiles) {
        this.removeStorageFile(storageFile.name, storageFilesToBeAdded)
      }
      for (let storageFolder of this.state.storageFolders) {
        this.removeStorageFile(storageFolder, storageFoldersToBeAdded)
      }
    } else {
      this.setState({ selectAllFiles: true })
      this.setState({ selectAllFilesClass: "fas fa-check-square pr-2" })
      for (let storageFile of this.state.storageFiles) {
        this.addStorageFile(storageFile.name, storageFilesToBeAdded)
      }
      for (let storageFolder of this.state.storageFolders) {
        this.addStorageFile(storageFolder, storageFoldersToBeAdded)
      }
    }
    this.setState({
      storageFiles: [...this.state.storageFiles],
      storageFilesToBeAdded: [...storageFilesToBeAdded],
      storageFolders: [...this.state.storageFolders],
      storageFoldersToBeAdded: [...storageFoldersToBeAdded]
    })
    // this.setState({ storageFilesToBeAdded: [...storageFilesToBeAdded] })
  }

  setSelectAllFilesIcon = (storageFilesToBeAdded, storageFoldersToBeAdded) => {
    let selectedFilesCount = 0
    for (let storageFile of this.state.storageFiles) {
      if (storageFilesToBeAdded.indexOf(storageFile.name) > -1) {
        selectedFilesCount += 1
      }
    }
    let selectedFoldersCount = 0
    for (let storageFolder of this.state.storageFolders) {
      if (storageFoldersToBeAdded.indexOf(storageFolder) > -1) {
        selectedFoldersCount += 1
      }
    }
    if (selectedFilesCount > 0 &&
      selectedFilesCount === this.state.storageFiles.length &&
      selectedFoldersCount > 0 &&
      selectedFoldersCount === this.state.storageFolders.length
    ) {
      this.setState({ selectAllFilesClass: "fas fa-check-square pr-2" })
      this.setState({ selectAllFiles: true })
    } else {
      this.setState({ selectAllFilesClass: "far fa-square pr-2" })
      this.setState({ selectAllFiles: false })
    }
  }

  onNavigationClick = (event) => {
    event.preventDefault()
    this.fetchStorageItems(event.target.dataset.name)
  }

  constructNavigation = () => {
    let currFolder = this.state.currFolder
    let homeNav = <BreadcrumbItem active>Home</BreadcrumbItem>
    if (currFolder) {
      homeNav = <BreadcrumbItem><a href={() => false} data-name='' onClick={this.onNavigationClick}>Home</a></BreadcrumbItem>
    }
    let navigations = [
      homeNav
    ]
    if (currFolder) {
      let prefixes = currFolder.split('/').slice(0, -1)
      let lastPrefix = prefixes.length > 0 ? prefixes.pop() : null
      let name = ''
      for (const prefix of prefixes) {
        name = name + prefix + '/'
        navigations.push(<BreadcrumbItem><a href={() => false} data-name={name} onClick={this.onNavigationClick}>{prefix}</a></BreadcrumbItem>)
      }
      if (lastPrefix) {
        navigations.push(<BreadcrumbItem active>{lastPrefix}</BreadcrumbItem>)
      }
    }
    this.setState({ storageNavigations: navigations })
  }

  getStorageFiles = () => {
    let storageFilesToBeAdded = null
    let storageFoldersToBeAdded = null
    // console.log('ChooseType', this.state.chooseType)
    if (this.state.chooseType === 'input') {
      storageFilesToBeAdded = this.state.setFiles_input
      storageFoldersToBeAdded = this.state.setFolders_input
    } else {
      storageFilesToBeAdded = this.state.setFiles_code
      storageFoldersToBeAdded = this.state.setFolders_code
    }
    return {
      storageFilesToBeAdded: storageFilesToBeAdded,
      storageFoldersToBeAdded: storageFoldersToBeAdded
    }
  }

  addStorageFile = (storageFile, storageFilesToBeAdded) => {
    const found = storageFilesToBeAdded.indexOf(storageFile)
    if (!(found > -1)) {
      storageFilesToBeAdded.push(storageFile)
    }
  }

  removeStorageFile = (storageFile, storageFilesToBeAdded) => {
    const found = storageFilesToBeAdded.indexOf(storageFile)
    if (found > -1) {
      storageFilesToBeAdded.splice(found, 1)
    }
  }

  updateStorageFiles = (storageFile, add) => {
    let storageFilesToBeAdded = [...this.state.storageFilesToBeAdded]

    if (add) {
      this.addStorageFile(storageFile, storageFilesToBeAdded)
    } else {
      this.removeStorageFile(storageFile, storageFilesToBeAdded)
    }
    this.setSelectAllFilesIcon(storageFilesToBeAdded, [...this.state.storageFoldersToBeAdded])
    this.setState({ storageFilesToBeAdded: [...storageFilesToBeAdded] })
  }

  updateStorageFolders = (storageFolder, add) => {
    let storageFoldersToBeAdded = [...this.state.storageFoldersToBeAdded]

    if (add) {
      this.addStorageFile(storageFolder, storageFoldersToBeAdded)
    } else {
      this.removeStorageFile(storageFolder, storageFoldersToBeAdded)
    }
    this.setSelectAllFilesIcon([...this.state.storageFilesToBeAdded], storageFoldersToBeAdded)
    this.setState({ storageFoldersToBeAdded: [...storageFoldersToBeAdded] })
  }

  cancelDialog = () => {
    this.setState({ showAddStorageModal: false, modalParameter: false });
  }

  SaveSelectedFiles = () => {
    if (this.state.editId !== '') {
      let setFiles = ''
      let setFolders = ''
      if (this.state.chooseType === "input") {
        setFiles = 'setFiles_input'
        setFolders = 'setFolders_input'
      } else {
        setFiles = 'setFiles_code'
        setFolders = 'setFolders_code'
      }
      this.state[setFiles].push(...this.state.storageFilesToBeAdded);
      this.state[setFolders].push(...this.state.storageFoldersToBeAdded)
      let _state = { showAddStorageModal: false }
      _state[setFiles] = [...new Set(this.state[setFiles])]
      _state[setFolders] = [...new Set(this.state[setFolders])]
      this.setState(_state)
    } else {
      this.state.chooseType === "input" ?
        this.setState({ setFiles_input: [...this.state.storageFilesToBeAdded], setFolders_input: [...this.state.storageFoldersToBeAdded] }) :
        this.setState({ setFiles_code: [...this.state.storageFilesToBeAdded], setFolders_code: [...this.state.storageFoldersToBeAdded] })
      this.setState({ showAddStorageModal: false });
    }
  }

  cancelProject = () => {
    this.props.history.push({
      pathname: '/Project',
    })
  }
  closeModal() {
    this.setState({ modalIsOpen: false, modalParameter: false });
  }
  handleClose = () => {
    this.setState({ isDialogOpen: false, logState: false, isRemoveDialogOpen: false, modalParameter: false })
  }

  handleScroll = (e) => {
    e.preventDefault()
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      // console.log("reached bottom")
      let prefix = null
      let files = []
      let folders = []
      let pageToken = null
      let isSideSplited = false
      prefix = this.state.currFolder
      files = this.state.storageFiles
      folders = this.state.storageFolders
      pageToken = this.state.nextPageToken
      this.setState({
        FilterFilesData: [],
        FilterFolderData: [],
      })
      if (pageToken) {
        this.setState({
          loadmoreFlag: true
        })
        this._fetchStorageItems(prefix, pageToken, files, folders, isSideSplited)
      } else {
        this.setState({
          loadmoreFlag: true
        })
      }
    }
  }


  OpenStorageView = (name, event,hidevalue) => {
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl1 = window.location.href;
    var parts = currentUrl1.split("/");
    let fromwhere = parts[parts.length - 1]
    let currentUrl = '';
    if (fromwhere === 'project') {
      currentUrl = currentUrl1.replace('/?__o=/project', '');
    }
    else if(fromwhere === 'runs'){
      currentUrl = currentUrl1.replace('/?__o=/runs', '');
    }
    else{
      currentUrl = currentUrl1.replace('/?__o=/viewProject/', '');
    }
    let reg = "/newProject";
    let path = name.slice(-1) === "/" ? "/storage?path=" + name : "/storageView?file=" + name + "&hideCodeCells=" + hidevalue; // check folder or file
    let redirectUrl = currentUrl.replace(reg, path);
    window.open(redirectUrl, "_blank");
  }
  copyAlert = () => {
    toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Copied!</b></i>); 
  }

  GetLink = (name, event, from) => {
    this.setState({ loading: true })
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl1 = window.location.href;
    var parts = currentUrl1.split("/");
    let fromwhere = parts[parts.length - 1]
    let currentUrl = '';
    if (fromwhere === 'project') {
      currentUrl = currentUrl1.replace('/?__o=/project', '');
    }
    else {
      currentUrl = currentUrl1.replace('/?__o=/runs', '');
    }
    let reg = "/newProject";
    let redirectUrl = currentUrl.replace(reg, "/storageView?file=" + name);

    TinyURL.shorten(redirectUrl).then((res) => {
      this.setState({ copiedtxt: res })
      var tempInput = document.createElement("input");
      tempInput.value = this.state.copiedtxt;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      if (from === "inputsource") {
        this.setState({ copiedinputsource: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      } else if (from === "code") {
        this.setState({ copiedcode: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      } else if (from === "inputsource2") {
        this.setState({ copiedinputsource2: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      } else if (from === "code2") {
        this.setState({ copiedcode2: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      }
    })
  }
  closeerror = () => {
    this.setState({ loading: false, copiedinputsource: "", copiedcode: "", copiedinputsource2: "", copiedcode2: "" })
  }

  // Download particular file in input or code
  downloadparticularFiles = (fileName, rid, type) => {
    StorageService.downloadObjectUrl(fileName)
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.download_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }
  handleChangeDetailedparam = (code) => {
    const { name, value } = code;
    this.state.parameterSet = code;
    this.state.detailedView_ParamSet = code;
    this.setState({ [name]: code });
    let newpara = this.state.detailedView_ParamSet
    RunService.getParaTable(newpara)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let parametersTables_array = []
          let parametersTables_files = response.parameterTables
          if (parametersTables_files !== null) {
            for (let index = 0; index < parametersTables_files.length; index++) {
              parametersTables_array.push(parametersTables_files[index])
            }
            this.setState({
              parametersTablesdata: parametersTables_array
            });
          }
          else {
            this.setState({
              parametersTablesdata: []
            });
          }
        }
      })
  }
  handleChangeparam(index, dataType, value) {
    let newState = this.state.parametersTablesdata.map((item, i) => {
      if (i === index) {
        return { ...item, [dataType]: value };
      }
      return item;
    });
    this.setState({
      parametersTablesdata: newState
    });
    this.ConstructParameterTable(newState)
  }
  getUploadedParameterSet() {
    let ps;
    ps = document.getElementById('textAreaParam').value
    this.setState({
      newparameterset: document.getElementById('textAreaParam').value,
    });
    this.ConvertParameter(ps)
  }
  // convert default view(table) to detailed view(string)
  ConstructParameterTable = (detailedView) => {
    let appendParamTable = "";
    for (var i = 0; i < detailedView.length; i++) {
      if (detailedView[i].key === null && detailedView[i].row === false) {
        appendParamTable = appendParamTable + detailedView[i].value + "\n";
      }
      else {
        if (detailedView[i].key === "" && detailedView[i].value === "") {
          appendParamTable = appendParamTable + detailedView[i].value + "\n";
        }
        else {
          appendParamTable = appendParamTable + detailedView[i].key + "=" + detailedView[i].value + "\n";
        }
      }
    }
    this.setState({
      detailedView_ParamSet: appendParamTable,
      parameterSet: appendParamTable
    })
  }
  //convert detailed view(string) to default view(table)
  ConvertParameter = (newparameterset) => {
    let newpara = newparameterset
    RunService.getParaTable(newpara)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let parametersTables_array = []
          let parametersTables_files = response.parameterTables
          if (parametersTables_files !== null) {
            for (let index = 0; index < parametersTables_files.length; index++) {
              parametersTables_array.push(parametersTables_files[index])
            }
            this.setState({
              parametersTablesdata: parametersTables_array
            });
          }
          else {
            this.setState({
              parametersTablesdata: []
            });
          }
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      });
  }
  handleAddRow = () => {
    if (this.state.parametersTablesdata.length !== 0) {
      let parsedJSON = this.state.parametersTablesdata.length - 1;
      let lastkeyRow = this.state.parametersTablesdata[parsedJSON].key;
      let lastvalueRow = this.state.parametersTablesdata[parsedJSON].value;
      if (lastkeyRow === "" && lastvalueRow === "") {
        // console.log('empty row')
      }
      else {
        const item = {
          key: "",
          value: ""
        };
        this.setState({
          parametersTablesdata: [...this.state.parametersTablesdata, item],
        });
      }
      this.ConstructParameterTable(this.state.parametersTablesdata)
    }
    else {
      const item = {
        key: "",
        value: ""
      };
      this.setState({
        parametersTablesdata: [...this.state.parametersTablesdata, item],
      });
      this.ConstructParameterTable(this.state.parametersTablesdata)
    }

  }
  // Delete Parameter Row
  handleDeleteRow = (index) => {
    this.setState({ deleteParameter: true, deleteindex: index })
  }

  confirmDeleteRows = (index) => {
    const rows = [...this.state.parametersTablesdata]
    rows.splice(index, 1)
    this.setState({ parametersTablesdata: rows })
    this.ConstructParameterTable(rows)
    this.setState({ deleteParameter: false })

  }
  CloseDeleteParameterModal = () => {
    this.setState({
      deleteParameter: false,
    })
  }

  toggleRunDropDown = () => {
    this.setState({ runDropDown: !this.state.runDropDown });
  };

  toggleScheduler = () => {
    this.setState({
      showScheduler: !this.state.showScheduler,
    });
  };

  handleClick = (e) => {
    e.preventDefault();
      if(e.type === "contextmenu") {
        var arrt = e.currentTarget.getAttribute("data_attr_id");
        document.getElementById(arrt).click();
    }  
  }

  render() {
    return (

      <>
        <PanelHeader
          content={
            <div className="header text-center">
            </div>
          }
        />
        <div className="content">
          <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
            <Row>
              <Col xs={12} md={12}>
                <Card>
                  <CardHeader className=" bg-transparent">
                    <Row className="align-items-center">
                      <div className="col">
                        <span className="text-center"><b>Project : </b> &nbsp;{this.state.projectName}</span>
                      </div>
                      <div className="col text-right">
                        {/* <Link to={this.state.pagehist}> */}
                        <div onClick={this.closeProject} style={{ cursor: 'pointer' }}>
                          <span className="close clear-filter">×</span>
                        </div>
                        {/* </Link> */}

                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <div className="carcontent">
                      <Scrollbars autoHeight autoHeightMin={this.state.sheight - 190}>
                        <Form onSubmit={this.SubmitProject} noValidate>
                          <br></br>
                          <div className="pl-lg-4" id="errorDiv">
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <label
                                    className="form-control-label"
                                    htmlFor="input-email"
                                  >
                                    Name
                            </label>
                                  <Input
                                    placeholder="Project Name"
                                    name="rname"
                                    type="text"
                                    value={this.state.rname}
                                    onChange={this.handleChange} noValidate
                                    className={this.state.hintName !== "" ? "df-error-outline form-control" : "form-control"} />
                                </FormGroup>
                                {this.state.hintName}
                              </Col>
                              <Col lg="6">
                                <FormGroup>
                                  <label
                                    className="form-control-label"
                                    htmlFor="input-email"
                                  >
                                    Description
                            </label>
                                  <Input
                                    className="form-control"
                                    placeholder="Description"
                                    name="description"
                                    value={this.state.description}
                                    type="text"
                                    onChange={this.handleChange} noValidate />
                                </FormGroup>
                              </Col>
                            </Row>
                            {/* Re-run and run project*/}
                            {((this.props.location.state.mode === "reRun") || (this.props.location.state.mode === "runProject")) &&
                              <div>
                                <Row>
                                  <Col lg="7">
                                    <label
                                      className="form-control-label"
                                      htmlFor="input-email"
                                    >
                                      Business Levers
                                          </label>
                                    <br></br>
                                    <div>
                                      <Table responsive className="table-hover paratbl" id="tab_logic">
                                        <thead>
                                          <tr>
                                            <th>Variables </th>
                                            <th style={{ width: "70%" }}> Values </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.parametersTablesdata.map((item, index) => (
                                            item.row !== false &&
                                            <tr id="addr0" key={index}>
                                              <td><Input
                                                className="form-control-alternative breaksen variabletxt"
                                                value={this.state.parametersTablesdata[index].key}
                                                style={{ border: 'none', borderRadius: '5px' }}
                                                id={uuidv4()}
                                                name="parameterSetkey"
                                                //onChange={this.handleChangeparam}
                                                onChange={(e) => this.handleChangeparam(index, 'key', e.target.value)}
                                                noValidate
                                                type="text"
                                              /></td>
                                              <td style={{ width: "50%" }}>
                                                <Input
                                                  className="form-control-alternative breaksen valuetxt"
                                                  //  value={item.value}
                                                  value={this.state.parametersTablesdata[index].value}
                                                  style={{ border: 'none', borderRadius: '5px' }}
                                                  id={uuidv4()}
                                                  name="parameterSet"
                                                  //onChange={this.handleChangeparam}
                                                  onChange={(e) => this.handleChangeparam(index, 'value', e.target.value)}
                                                  noValidate
                                                  type="text"
                                                />
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </Table>
                                    </div>
                                    {this.state.parametersTablesdata.length === 0 && <span style={{ color: 'darkgray', fontSize: '14px' }}>  &nbsp; No Business Levers Found</span>}
                                  </Col>
                                  <Col lg="1">
                                    <br></br>
                                    <br></br> <img src={open} onClick={this.toggleModalParameter} alt="" style={{ cursor: 'pointer', width: '30px', height: '30px' }} />
                                  </Col>
                                </Row>
                                <br></br>
                                <Row>
                                  <Col lg="12">
                                    <div
                                      aria-multiselectable={true}
                                      className="card-collapse"
                                      id="advanceaccordion"
                                      role="tablist"
                                    >

                                      <CardHeader role="tab">
                                        <a
                                          aria-expanded={this.state.openedadvanceCollapses.includes(
                                            "collapseAdvance"
                                          )}
                                          href="#pablo"
                                          data-parent="#advanceaccordion"
                                          data-toggle="collapse"
                                          onClick={e => {
                                            e.preventDefault();
                                            this.collapsesAdvanceToggle("collapseAdvance");
                                          }}
                                        >
                                          <label
                                            className="form-control-label"
                                            htmlFor="input-email"
                                            style={{ cursor: 'pointer' }}
                                          >
                                            Advanced &nbsp;  <i className={this.state.advanceicon} />
                                          </label>

                                        </a>
                                      </CardHeader>
                                      <Collapse
                                        role="tabpanel"
                                        isOpen={this.state.openedadvanceCollapses.includes(
                                          "collapseAdvance"
                                        )}
                                      >
                                        <CardBody>

                                          <Row className="justify-content-center">
                                            <Col lg={12} md={12} xs={12}>
                                              <Card>
                                                <CardBody>
                                                  <div
                                                    aria-multiselectable={true}
                                                    className="card-collapse"
                                                    id="accordion"
                                                    role="tablist"
                                                  >
                                                    {/* 0th */}
                                                    <Card className="card-plain">
                                                      <CardHeader role="tab">
                                                        <a
                                                          aria-expanded={this.state.openedCollapses.includes(
                                                            "collapseZero"
                                                          )}
                                                          href="#pablo"
                                                          data-parent="#accordion"
                                                          data-toggle="collapse"
                                                          onClick={e => {
                                                            e.preventDefault();
                                                            this.collapsesToggle("collapseZero");
                                                          }}
                                                        >
                                                          <label
                                                            className="form-control-label"
                                                            htmlFor="input-email"
                                                          > Tags </label> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                                                        </a>
                                                      </CardHeader>
                                                      <Collapse
                                                        role="tabpanel"
                                                        isOpen={this.state.openedCollapses.includes(
                                                          "collapseZero"
                                                        )}
                                                      >
                                                        <CardBody>
                                                          <Row>
                                                            <Col lg="12">
                                                              <Scrollbars autoHeight autoHeightMin={50} autoHeightMax={150}>
                                                                {this.state.tags.map((item, index) => (
                                                                  <Chip
                                                                    key={index}
                                                                    label={item}
                                                                    size="small"
                                                                    onDelete={(chip) => this.removeChip(index)}
                                                                    style={{ background: this.getColor(), color: "#fff", fontWeight: 600, marginTop: 5, marginLeft: 3 }}
                                                                  />)
                                                                )}
                                                                <ChipInput
                                                                  value={this.state.tags}
                                                                  placeholder="Add a Tag"
                                                                  onAdd={value => this.addChip(value)}
                                                                />
                                                              </Scrollbars><br />
                                                            </Col>
                                                          </Row>
                                                        </CardBody>
                                                      </Collapse>
                                                    </Card>

                                                    {/*1st*/}
                                                    <Card className="card-plain">
                                                      <CardHeader role="tab">
                                                        <a
                                                          aria-expanded={this.state.openedCollapses.includes(
                                                            "collapseOne"
                                                          )}
                                                          href="#pablo"
                                                          data-parent="#accordion"
                                                          data-toggle="collapse"
                                                          onClick={e => {
                                                            e.preventDefault();
                                                            this.collapsesToggle("collapseOne");
                                                          }}
                                                        >
                                                          Input Source  &nbsp;<b><span style={styles.error}>{this.state.copiedinputsource}</span></b>
                                                          <i className="now-ui-icons arrows-1_minimal-down" />
                                                        </a>
                                                      </CardHeader>
                                                      <Collapse
                                                        role="tabpanel"
                                                        isOpen={this.state.openedCollapses.includes(
                                                          "collapseOne"
                                                        )}
                                                      >
                                                        <CardBody>
                                                          <Row>
                                                            <Col lg="6">
                                                              <FormGroup>
                                                                <Row>
                                                                  <Button color="primary" style={{ marginLeft: "10px" }}
                                                                    id="addStorageItem1"
                                                                    size="sm"
                                                                    onClick={
                                                                      e => {
                                                                        e.preventDefault()
                                                                        this.setState({ chooseType: 'input' }, () => {
                                                                          this.toggleAddStorageItem()
                                                                        })
                                                                      }
                                                                    }
                                                                  >
                                                                    <span className="btn-label">
                                                                      <i className="fas fa-plus-circle"></i>
                                                                    </span>
                                                    &nbsp;Add
                                                  </Button>
                                                                  <Button color="link"
                                                                    onClick={e => {
                                                                      e.preventDefault()
                                                                      this.removeAll('input')
                                                                    }}
                                                                  >
                                                                    Remove All
                                                  </Button>
                                                                </Row>
                                                                <div className={(this.state.setFolders_input.length + this.state.setFiles_input.length) > 7 ? "scrollit" : ""}>
                                                                  <ListGroup>
                                                                    {this.state.setFolders_input.map((item, index) => (
                                                                      <ListGroupItem key={'input-' + index} className="project-item">
                                                                        <a href={() => false} className="text-primary" style={styles.chaticon} onClick={e => this.OpenStorageView(item, e, this.state.hideCodeCells)}>
                                                                          <i className="fas fa-folder pr-1"></i>
                                                                          {item}
                                                                          <i className="far fa-times-circle filepadding text-red fontRed" 
                                                                            onClick={e => {
                                                                              e.stopPropagation()
                                                                              this.RemoveFiles(this.state.setFolders_input, item, 'input', true)
                                                                            }}></i>
                                                                        </a>
                                                                      </ListGroupItem>
                                                                    ))}
                                                                    {this.state.setFiles_input.map((item, index) => (
                                                                      <ListGroupItem key={'input-' + index} className="project-item">
                                                                        <UncontrolledDropdown direction={(index > 4 ? "up" : "right")}>
                                                                        <span className="file" data-type="file"
                                                                          data_attr_id={"codeId"+index}
                                                                          onContextMenu={this.handleClick}>
                                                                          <a href={()=> false} className="text-primary"
                                                                            style={styles.chaticon} >
                                                                            <i
                                                                              className={getImageFile(imageFileExtension(item))}></i>
                                                                            {item}
                                                                            <i className="far fa-times-circle filepadding text-red fontRed"
                                                                              onClick={e=> {
                                                                              e.stopPropagation()
                                                                              this.RemoveFiles(this.state.setFiles_input,
                                                                              item, 'input')
                                                                              }}></i>
                                                                          </a>
                                                                        </span>
                                                                          <DropdownToggle tag="span" id={"codeId"+index}>                                                                            
                                                                          </DropdownToggle>
                                                                          <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                                                            <DropdownItem
                                                                              onClick={e => this.OpenStorageView(item, e,this.state.hideCodeCells)}
                                                                            >
                                                                              <span >
                                                                                <i className="fas fa-binoculars mr-2"></i> View
                                                                              </span>
                                                                            </DropdownItem>
                                                                            <DropdownItem
                                                                              onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                                                            >
                                                                              <span >
                                                                                <i className="fas fa-download mr-2" /> Download
                                                                              </span>
                                                                            </DropdownItem>
                                                                            <DropdownItem
                                                                              onClick={e => this.GetLink(item, e, 'inputsource')}>
                                                                              <div>
                                                                                <i className=" fas fa-link mr-2" />
                                                                                <span>Get Sharable Link</span>
                                                                              </div>
                                                                            </DropdownItem>

                                                                          </DropdownMenu>
                                                                        </UncontrolledDropdown>
                                                                      </ListGroupItem>
                                                                    ))}
                                                                  </ListGroup>
                                                                </div>
                                                              </FormGroup>
                                                            </Col>

                                                            <Col lg="3">
                                                              <FormGroup className="mt-3">
                                                                <label >
                                                                  <Input type="checkbox" id="inputfilescheck1" onChange={this.handleSaveInputFile} checked={this.state.inputFilesRequired} />{' '}
                                            Save Input Files
                                           </label>
                                                              </FormGroup>
                                                              {this.state.inputFilesRequired === true &&
                                                                <FormGroup className="mt-3">
                                                                  <label>
                                                                    <Input type="checkbox" id="inputfilescheck2" onChange={this.handleRerunSaveInputFile} checked={this.state.rerunFromSavedInputFiles} />{' '}
                                            Rerun from Saved Input
                                           </label>
                                                                </FormGroup>
                                                              }
                                                              <FormGroup>
                                                                <UncontrolledTooltip placement="top" target="addStorageItem1" delay={0}>
                                                                  Add from Storage
                          </UncontrolledTooltip>
                                                                <Modal
                                                                  size="xl"
                                                                  className="add-storage-item-modal ModalWidth"
                                                                  isOpen={this.state.showAddStorageModal}
                                                                  toggle={this.toggleAddStorageItem}
                                                                  backdrop="static"
                                                                  returnFocusAfterClose={false}
                                                                >
                                                                  <Card className=" shadow">
                                                                    <CardBody>
                                                                      <Tabs
                                                                        defaultTab="DFRepo"
                                                                        onChange={(tabId) => {
                                                                          // console.log(tabId) 
                                                                        }}
                                                                      >
                                                                        <TabList>
                                                                          <Row>
                                                                            <div className="col">
                                                                              {/* <Tab tabFor="Recent" className="adddatatab"><i className="fas fa-sync-alt"></i>&nbsp; Recent</Tab> */}
                                                                              <Tab tabFor="DFRepo" className="adddatatab"><img src={dfrepo} style={{ width: '20px', height: '20px' }} alt="" ></img> &nbsp; DF Repo</Tab>
                                                                              {/* <Tab tabFor="Local"><i className="fas fa-desktop"></i>&nbsp; Local</Tab> */}
                                                                              <Tab tabFor="Github" disabled className="adddatatab hideTab"><i className="fab fa-github"></i>&nbsp; Github</Tab>
                                                                            </div>
                                                                            <div className="col text-right">
                                                                              <span style={{ cursor: 'pointer' }} onClick={e => this.cancelDialog()}>
                                                                                <i className="fas fa-times text-red mr-3"></i>
                                                                              </span>
                                                                            </div>
                                                                          </Row>
                                                                        </TabList>
                                                                        {/* <Scrollbars autoHeight autoHeightMin={400}> */}
                                                                        {/* <TabPanel tabId="Recent">
                                                        <p>Recent files</p>
                                                      </TabPanel> */}
                                                                        <TabPanel tabId="DFRepo">
                                                                          <ModalBody>
                                                                            <Scrollbars autoHeight autoHeightMin={400}>
                                                                              <CardBody className="border-top storage-content equalheight" onScroll={this.handleScroll}>
                                                                                <div className="clearfix">
                                                                                  <Row>
                                                                                    <Col md="6" xs="6">
                                                                                      <span className="select-all">
                                                                                        <i
                                                                                          className={this.state.selectAllFilesClass}
                                                                                          onClick={this.selectAllFilesClick}
                                                                                        ></i>
                                                                                      </span> Select All Files
                                        </Col>
                                                                                    <Col md="2" xs="2">
                                                                                      <span>File Size</span>
                                                                                    </Col>
                                                                                    <Col md="3" xs="3">
                                                                                      <span>Date Created </span>
                                                                                    </Col>
                                                                                    <Col md="1" xs="1">
                                                                                      <Button
                                                                                        id="upload"
                                                                                        color="link"
                                                                                        onClick={this.toggleUpload} style={{ marginTop: '-3px' }}>
                                                                                        <i className="fas fa-cloud-upload-alt"></i>
                                                                                      </Button>
                                                                                      <UncontrolledTooltip placement="top" target="upload" delay={0}>
                                                                                        Upload
                                        </UncontrolledTooltip>
                                                                                    </Col>
                                                                                  </Row>

                                                                                  <Modal
                                                                                    centered
                                                                                    className="upload-modal"
                                                                                    isOpen={this.state.showUploadModal}
                                                                                    toggle={this.toggleUpload}
                                                                                    backdrop="static"
                                                                                    returnFocusAfterClose={false}
                                                                                  >
                                                                                    <ModalHeader toggle={this.toggleUpload}>File Uploads</ModalHeader>
                                                                                    <ModalBody>
                                                                                      <FilePond ref={ref => this.pond = ref}
                                                                                        allowMultiple={true}
                                                                                        maxFiles={10}
                                                                                        server={{
                                                                                          process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {

                                                                                            const CancelToken = axios.CancelToken;
                                                                                            const source = CancelToken.source();

                                                                                            const fileToBeUpload = file
                                                                                            const currFolder = !this.state.currFolder ? '' : this.state.currFolder
                                                                                            const objectName = path.join(currFolder, fileToBeUpload.name)
                                                                                            StorageService.uploadObjectUrl(objectName, null, null)
                                                                                              .then((response) => {
                                                                                                axios({
                                                                                                  url: response.upload_url,
                                                                                                  baseURL: '',
                                                                                                  data: {},
                                                                                                  headers: {
                                                                                                    'content-type': fileToBeUpload.type,
                                                                                                    'x-goog-resumable': 'start'
                                                                                                  },
                                                                                                  method: 'POST',
                                                                                                  cancelToken: source.token
                                                                                                }).then((resp) => {
                                                                                                  const resumableLink = resp.headers.location
                                                                                                  console.log('Uploading...', fileToBeUpload.name)
                                                                                                  CommonService({
                                                                                                    url: resumableLink,
                                                                                                    baseURL: '',
                                                                                                    data: fileToBeUpload,
                                                                                                    headers: {
                                                                                                      'content-type': "multipart/form-data"
                                                                                                    },
                                                                                                    method: 'PUT',
                                                                                                    cancelToken: source.token,
                                                                                                    onUploadProgress: function (e) {
                                                                                                      progress(e.lengthComputable, e.loaded, e.total)
                                                                                                    }
                                                                                                  }).then((resp) => {
                                                                                                    load(fileToBeUpload.name)
                                                                                                    console.log('Uploaded!', fileToBeUpload.name)
                                                                                                    this.fetchStorageItems(this.state.currFolder || '')
                                                                                                  })
                                                                                                })
                                                                                              })
                                                                                            return {
                                                                                              abort: () => {
                                                                                                // This function is entered if the user has tapped the cancel button
                                                                                                source.cancel()

                                                                                                // Let FilePond know the request has been cancelled
                                                                                                abort();
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        }}
                                                                                      >
                                                                                      </FilePond>
                                                                                    </ModalBody>
                                                                                  </Modal>
                                                                                </div>
                                                                                <AddStorageItems
                                                                                  folders={this.state.storageFolders}
                                                                                  files={this.state.storageFiles}
                                                                                  fetchStorageItems={this.fetchStorageItems}
                                                                                  loadmoreFlag={this.state.loadmoreFlag}
                                                                                  nextPageToken={this.state.nextPageToken}
                                                                                  chooseType={this.state.chooseType}
                                                                                  storageFilesToBeAdded={this.state.storageFilesToBeAdded}
                                                                                  storageFoldersToBeAdded={this.state.storageFoldersToBeAdded}
                                                                                  updateStorageFiles={this.updateStorageFiles}
                                                                                  updateStorageFolders={this.updateStorageFolders}
                                                                                  selectAllFiles={this.state.selectAllFiles}
                                                                                  selectAllFilesClass={this.state.selectAllFilesClass}
                                                                                />
                                                                              </CardBody>
                                                                              {this.state.nextPageToken === null && <Row>
                                                                                <Col style={{ textAlign: "center" }}>
                                                                                  <span style={{ fontSize: 13, color: "#8c8b8b" }}>-- Page End --</span>
                                                                                </Col>
                                                                              </Row>}
                                                                            </Scrollbars>
                                                                            <CardFooter className="storage-navigation">
                                                                              <Row>
                                                                                <div className="col">
                                                                                  <Breadcrumb listClassName="bg-transparent storage-nav-breadcrumb" listTag="div">
                                                                                    {this.state.storageNavigations}
                                                                                  </Breadcrumb>
                                                                                </div>
                                                                                <div className="col text-right">
                                                                                  <Button color="secondary" style={{ marginLeft: "10px" }}
                                                                                    id="addStorageItem2"
                                                                                    size="sm"
                                                                                    onClick={e => this.cancelDialog()} >
                                                                                    <span className="btn-label">
                                                                                      <i className="fas fa-times-circle"></i>
                                                                                    </span>
                                &nbsp;Cancel
                              </Button>
                                                                                  <Button style={{ marginLeft: "20px" }} color="primary"
                                                                                    id="addStorageItem2"
                                                                                    size="sm"
                                                                                    onClick={e => this.SaveSelectedFiles()}>
                                                                                    <span className="btn-label">
                                                                                      <i className="fas fa-save"></i>
                                                                                    </span>
                                &nbsp;Save
                              </Button>
                                                                                </div>
                                                                              </Row>

                                                                            </CardFooter>

                                                                          </ModalBody>
                                                                        </TabPanel>

                                                                        <TabPanel tabId="Local">
                                                                          <br></br>
                                                                          <p>Local</p>
                                                                        </TabPanel>
                                                                        <TabPanel tabId="Github">
                                                                          <p>Github</p>
                                                                        </TabPanel>
                                                                        {/* </Scrollbars> */}
                                                                      </Tabs>
                                                                    </CardBody>

                                                                  </Card>
                                                                </Modal>
                                                              </FormGroup>
                                                            </Col>
                                                            <Col lg="3">
                                                              {this.state.recentFilesInput.length > 0 && <FormGroup>
                                                                <label
                                                                  className="form-control-label"
                                                                  htmlFor="input-first-name"
                                                                >
                                                                  Recent uploads
                            </label>
                                                                {this.state.recentFilesInput.length > 0 && <div className="custom-control custom-control-alternative custom-checkbox">
                                                                  <input
                                                                    className="custom-control-input"
                                                                    id=" customCheckLogin"
                                                                    type="checkbox"
                                                                    onChange={this.handleChangeInput}
                                                                  />

                                                                  <label
                                                                    className="custom-control-label"
                                                                    htmlFor=" customCheckLogin"
                                                                  >
                                                                  </label>
                                                                </div>}

                                                                {this.state.recentInputfolders.map(item => (

                                                                  <div style={styles.leftAlign}>
                                                                    <span
                                                                    >
                                                                      {item.folder}

                                                                    </span>
                                                                    <ul>
                                                                      <li>
                                                                        <span className="text-primary" ><a href={() => false}><u>{item.file}</u></a></span>
                                                                      </li>
                                                                    </ul>
                                                                  </div>
                                                                ))}

                                                              </FormGroup>}
                                                            </Col>
                                                          </Row>
                                                        </CardBody>
                                                      </Collapse>
                                                    </Card>
                                                    {/*2nd*/}
                                                    <Card className="card-plain">
                                                      <CardHeader role="tab">
                                                        <a
                                                          aria-expanded={this.state.openedCollapses.includes(
                                                            "collapseTwo"
                                                          )}
                                                          href="#pablo"
                                                          data-parent="#accordion"
                                                          data-toggle="collapse"
                                                          onClick={e => {
                                                            e.preventDefault();
                                                            this.collapsesToggle("collapseTwo");
                                                          }}
                                                        >
                                                          Code &nbsp;<b><span style={styles.error}>{this.state.copiedcode}</span></b>
                                                          <i className="now-ui-icons arrows-1_minimal-down" />
                                                        </a>
                                                      </CardHeader>
                                                      <Collapse
                                                        role="tabpanel"
                                                        isOpen={this.state.openedCollapses.includes(
                                                          "collapseTwo"
                                                        )}
                                                      >
                                                        <CardBody>
                                                          {this.state.setFiles_code.length === 0 && this.state.setFolders_code.length === 0 && <Row>
                                                            <Col>
                                                              {this.state.hintCodeFiles}
                                                            </Col>
                                                          </Row>}
                                                          <Row>
                                                            <Col lg="6">
                                                              <FormGroup>
                                                                <Row>
                                                                  <Button color="primary" style={{ marginLeft: "10px" }}
                                                                    id="addStorageItem3"
                                                                    size="sm"
                                                                    onClick={
                                                                      e => {
                                                                        e.preventDefault()
                                                                        this.setState({ chooseType: 'code' }, () => {
                                                                          this.toggleAddStorageItem()
                                                                        })
                                                                      }
                                                                    }
                                                                  >
                                                                    <span className="btn-label">
                                                                      <i className="now-ui-icons ui-1_simple-add"></i>
                                                                    </span>
                                                  &nbsp;Add
                                                </Button>
                                                                  <Button color="link"
                                                                    onClick={e => {
                                                                      e.preventDefault()
                                                                      this.removeAll('code')
                                                                    }}
                                                                  >
                                                                    Remove All
                                                  </Button>
                                                                </Row>
                                                                <div className={(this.state.setFolders_code.length + this.state.setFiles_code.length) > 7 ? "scrollit" : ""}>
                                                                  <ListGroup>
                                                                    {this.state.setFolders_code.map((item, index) => (
                                                                      <ListGroupItem key={'code-' + index} className="project-item">
                                                                        <a href={() => false} className="text-primary" style={styles.chaticon} onClick={e => this.OpenStorageView(item, e,this.state.hideCodeCells)}>
                                                                          <i className="fas fa-folder pr-1"></i>
                                                                          {item}
                                                                          <i className="far fa-times-circle filepadding text-red fontRed" 
                                                                            onClick={e => {
                                                                              e.stopPropagation()
                                                                              this.RemoveFiles(this.state.setFolders_code, item, 'code', true)
                                                                            }}></i>
                                                                        </a>
                                                                      </ListGroupItem>
                                                                    ))}
                                                                    {this.state.setFiles_code.map((item, index) => (
                                                                      <ListGroupItem key={'code-' + index} className="project-item">
                                                                        <UncontrolledDropdown direction={(index > 4 ? "up" : "right")}>
                                                                        <span className="file" data-type="file"
                                                                          data_attr_id={"codeId"+index+"1"}
                                                                          onContextMenu={this.handleClick}>
                                                                          <a href={()=> false} className="text-primary"
                                                                            style={styles.chaticon} >
                                                                            <i
                                                                              className={getImageFile(imageFileExtension(item))}></i>
                                                                            {item}
                                                                            <i className="far fa-times-circle filepadding text-red fontRed"
                                                                              onClick={e=> {
                                                                              e.stopPropagation()
                                                                              this.RemoveFiles(this.state.setFiles_code,
                                                                              item, 'code')
                                                                              }}></i>
                                                                          </a>
                                                                        </span>
                                                                        <DropdownToggle tag="span" id={"codeId"+index+"1"}>
                                                                        </DropdownToggle>
                                                                          <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                                                            <DropdownItem
                                                                              onClick={e => this.OpenStorageView(item, e,this.state.hideCodeCells)}
                                                                            >
                                                                              <span >
                                                                                <i className="fas fa-binoculars mr-2"></i> View
                                                                              </span>
                                                                            </DropdownItem>
                                                                            <DropdownItem
                                                                              onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                                                            >
                                                                              <span >
                                                                                <i className="fas fa-download mr-2" /> Download
                                                                              </span>
                                                                            </DropdownItem>
                                                                            <DropdownItem
                                                                              onClick={e => this.GetLink(item, e, 'code')}>
                                                                              <div>
                                                                                <i className=" fas fa-link mr-2" />
                                                                                <span>Get Sharable Link</span>
                                                                              </div>
                                                                            </DropdownItem>

                                                                          </DropdownMenu>
                                                                        </UncontrolledDropdown>
                                                                      </ListGroupItem>
                                                                    ))}
                                                                  </ListGroup>
                                                                </div>
                                                              </FormGroup>
                                                            </Col>
                                                            <Col lg="3">
                                                              <FormGroup className="mt-3">
                                                                <label>
                                                                  <Input type="checkbox" id="inputcodefiles" onChange={this.handleSaveInputCode} checked={this.state.inputCodeFilesRequired} />{' '}
                                              Save Input Code Files
                                              </label>
                                                              </FormGroup>
                                                              {this.state.inputCodeFilesRequired === true &&
                                                                <FormGroup className="mt-3">
                                                                  <label>
                                                                    <Input type="checkbox" id="inputfilescheck3" onChange={this.handleRerunSaveInputFileCode} checked={this.state.rerunFromSavedCodeFiles} />{' '}
                                            Rerun from Saved Code
                                           </label>
                                                                </FormGroup>
                                                              }
                                                            </Col>
                                                            <Col lg="3">
                                                              {this.state.recentFilesCode.length > 0 && <FormGroup>
                                                                <label
                                                                  className="form-control-label"
                                                                  htmlFor="input-first-name"
                                                                >
                                                                  Recent uploads
                            </label>
                                                                {this.state.recentFilesCode.length > 0 && <div className="custom-control custom-control-alternative custom-checkbox">
                                                                  <input
                                                                    className="custom-control-input"
                                                                    id=" customCheckcode"
                                                                    type="checkbox"
                                                                    onChange={this.handleChangeCode}
                                                                  />
                                                                  <label
                                                                    className="custom-control-label"
                                                                    htmlFor=" customCheckcode"
                                                                  >
                                                                  </label>
                                                                </div>}

                                                                {this.state.recentCodefolders.map(item => (

                                                                  <div style={styles.leftAlign}>
                                                                    <span>
                                                                      {item.folder}

                                                                    </span>
                                                                    <ul>
                                                                      <li>
                                                                        <span className="text-primary" ><a href={() => false}><u>{item.file}</u></a></span>
                                                                      </li>
                                                                    </ul>
                                                                  </div>
                                                                ))}
                                                              </FormGroup>}
                                                            </Col>

                                                          </Row>
                                                        </CardBody>
                                                      </Collapse>
                                                    </Card>
                                                    {/*3rd*/}
                                                    <Card className="card-plain">
                                                      <CardHeader role="tab">
                                                        <a
                                                          aria-expanded={this.state.openedCollapses.includes(
                                                            "collapseFour"
                                                          )}
                                                          href="#pablo"
                                                          data-parent="#accordion"
                                                          data-toggle="collapse"
                                                          onClick={e => {
                                                            e.preventDefault();
                                                            this.collapsesToggle("collapseFour");
                                                          }}
                                                        >
                                                          Dependencies / Libraries
                          <i className="now-ui-icons arrows-1_minimal-down" />
                                                        </a>
                                                      </CardHeader>
                                                      <Collapse
                                                        role="tabpanel"
                                                        isOpen={this.state.openedCollapses.includes(
                                                          "collapseFour"
                                                        )}
                                                      >
                                                        <CardBody>
                                                          <Row>
                                                            <Col lg="6">
                                                              <div>
                                                                <label
                                                                  className="form-control-label"
                                                                  htmlFor="input-email"
                                                                >
                                                                  Python Libraries (as CSV)
                            </label>
                                                                <FilePond
                                                                  files={this.state.pythonfiles}
                                                                  allowMultiple={true}
                                                                  maxFiles={1}
                                                                  labelIdle='Drag & Drop your files or <span className="filepond--label-action">Browse</span>'
                                                                  server={{
                                                                    // fake server to simulate loading a 'local' server file and processing a file
                                                                    process: (fieldName, file, metadata, load) => {
                                                                      // simulates uploading a file
                                                                      setTimeout(() => {
                                                                        load(Date.now());
                                                                      }, 1500);
                                                                    },
                                                                    load: (source, load) => {
                                                                      // simulates loading a file from the server
                                                                      fetch(source)
                                                                        .then(res => {
                                                                          //console.log(res);
                                                                          return res.blob();
                                                                        })
                                                                        .then(blob => {
                                                                          //console.log(blob);
                                                                          return load(blob);
                                                                        });
                                                                    }
                                                                  }}
                                                                  oninit={() => this.handleInit()}
                                                                  onupdatefiles={fileItems => {
                                                                    this.setState({
                                                                      pythonfiles: fileItems.map(fileItem => fileItem.file)
                                                                    });
                                                                    if (this.state.pythonfiles.length > 0) {
                                                                      var fr = new FileReader();
                                                                      fr.readAsText(this.state.pythonfiles[0]);
                                                                      fr.onload = function (event) {
                                                                        document.getElementById("textAreaPythonParam").value = event.target.result;
                                                                      }
                                                                    } else {
                                                                      document.getElementById("textAreaPythonParam").value = "";
                                                                    }
                                                                  }}
                                                                />
                                                              </div>
                                                            </Col>
                                                            <Col lg="6">
                                                              <FormGroup>
                                                                <Input
                                                                  className="form-control-alternative"
                                                                  placeholder="Python libraries"
                                                                  // disabled
                                                                  rows="4"
                                                                  style={styles.rowAlign}
                                                                  id="textAreaPythonParam"
                                                                  type="textarea"
                                                                  name="pyLibrary"
                                                                  onChange={this.handleChange} noValidate
                                                                />
                                                              </FormGroup>
                                                              <span style={styles.textAreaHint}>Example: pandas==0.25.3, tensforflow, pytorch, python-opencv</span>
                                                            </Col>
                                                          </Row>
                                                        </CardBody>
                                                      </Collapse>
                                                    </Card>
                                                    {/*4th*/}
                                                    <Card className="card-plain" id="clusterName">
                                                      <CardHeader role="tab">
                                                        <a
                                                          aria-expanded={this.state.openedCollapses.includes(
                                                            "collapseFive"
                                                          )}
                                                          href="#pablo"
                                                          data-parent="#accordion"
                                                          data-toggle="collapse"
                                                          onClick={e => {
                                                            e.preventDefault();
                                                            this.collapsesToggle("collapseFive");
                                                          }}
                                                        >
                                                          Compute Size
                          <i className="now-ui-icons arrows-1_minimal-down" />
                                                        </a>
                                                      </CardHeader>
                                                      <Collapse
                                                        role="tabpanel"
                                                        isOpen={this.state.openedCollapses.includes(
                                                          "collapseFive"
                                                        )}
                                                      >
                                                        <CardBody>
                                                          <Row>
                                                            <Col lg="6">
                                                              <FormGroup>
                                                                <label
                                                                  className="form-control-label"
                                                                  htmlFor="input-username"
                                                                >
                                                                  Select a Machine Type / Cluster
                                               </label>

                                                                <Select name="clusterName"
                                                                  value={this.state.clusteroptions.filter(item => item.value === this.state.clusterName)}
                                                                  options={this.state.clusteroptions}
                                                                  onChange={this.handleChangeSelect}
                                                                  noValidate
                                                                  className={this.state.hintVmCluster !== "" ? "df-error-outline" : ""} />

                                                              </FormGroup>
                                                              {this.state.hintVmCluster}
                                                            </Col>
                                                            <Col lg="6">
                                                              <FormGroup>
                                                                <label
                                                                  className="form-control-label"
                                                                  htmlFor="input-username"
                                                                >
                                                                  Runtime
                                            </label>
                                                                <Select name="kernelName"
                                                                  // value={{label : this.state.kernelName}}
                                                                  value={this.state.runTimeOptions.filter(item => item.value === this.state.kernelId)}
                                                                  options={this.state.runTimeOptions}
                                                                  onChange={this.handleChangeSelectKernel}
                                                                  noValidate
                                                                  className={this.state.hintRunTime !== "" ? "df-error-outline" : ""} />
                                                              </FormGroup>
                                                              {this.state.hintRunTime}
                                                            </Col>
                                                          </Row>
                                                        </CardBody>
                                                      </Collapse>
                                                    </Card>
                                                    {/*5th*/}
                                                    <Card className="card-plain">
                                                      <CardHeader role="tab">
                                                        <a
                                                          aria-expanded={this.state.openedCollapses.includes(
                                                            "collapseSix"
                                                          )}
                                                          href="#pablo"
                                                          data-parent="#accordion"
                                                          data-toggle="collapse"
                                                          onClick={e => {
                                                            e.preventDefault();
                                                            this.collapsesToggle("collapseSix");
                                                          }}
                                                        >
                                                          Others
                          <i className="now-ui-icons arrows-1_minimal-down" />
                                                        </a>
                                                      </CardHeader>
                                                      <Collapse
                                                        role="tabpanel"
                                                        isOpen={this.state.openedCollapses.includes(
                                                          "collapseSix"
                                                        )}
                                                      >
                                                        <CardBody>
                                                          <Row>
                                                            <Col lg="6">
                                                              <FormGroup>
                                                                <label
                                                                  className="form-control-label"
                                                                  htmlFor="input-username"
                                                                >
                                                                  Choose File Delimiter
                            </label>
                                                                <Select name="delimiterName"
                                                                  value={delimiteroptions.filter(item => item.value === this.state.delimiter)}
                                                                  options={delimiteroptions} onChange={this.handleChangeSelectDelimiter} noValidate />
                                                              </FormGroup>
                                                            </Col>
                                                            <Col lg="2">
</Col>
                   
                                                            <Col lg="4">
                                                            <FormGroup>
                                                              <br></br>
                                                                  <label>
                                                                    <Input type="checkbox" id="inputfilescheck3" onChange={this.handleHideModelCell} checked={this.state.hideCodeCells} />{' '}
                                            Hide Code Cells
                                           </label>
                                                                </FormGroup>
                                                            </Col>
                                                          </Row>
                                                        </CardBody>
                                                      </Collapse>
                                                    </Card>
                                                  </div>
                                                </CardBody>
                                              </Card>
                                            </Col>
                                            <Col lg={6} md={8} xs={12}>
                                            </Col>
                                          </Row>
                                        </CardBody>
                                      </Collapse>

                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            }
                            {/* Edit project*/}
                            {((this.props.location.state.mode === "editProject") || (this.props.location.state.mode === "addnew") || (this.props.location.state.mode === "cloneProject")) &&
                              //  <Scrollbars autoHeight autoHeightMax={300}>
                              <div>
                                <Row >
                                  <Col lg={12} md={12} xs={12}>

                                    <div
                                      aria-multiselectable={true}
                                      className="card-collapse"
                                      id="accordion"
                                      role="tablist"
                                    >
                                      {/* 0th */}
                                      <Card className="card-plain">
                                        <CardHeader role="tab">
                                          <a
                                            aria-expanded={this.state.openedCollapses.includes(
                                              "collapseZero"
                                            )}
                                            href="#pablo"
                                            data-parent="#accordion"
                                            data-toggle="collapse"
                                            onClick={e => {
                                              e.preventDefault();
                                              this.collapsesToggle("collapseZero");
                                            }}
                                          >
                                            <label
                                              className="form-control-label"
                                              htmlFor="input-email"
                                            > Tags </label> &nbsp;
                          <i className="now-ui-icons arrows-1_minimal-down" />
                                          </a>
                                        </CardHeader>
                                        <Collapse
                                          role="tabpanel"
                                          isOpen={this.state.openedCollapses.includes(
                                            "collapseZero"
                                          )}
                                        >
                                          <CardBody>
                                            <Row>
                                              <Col lg="12">
                                                <Scrollbars autoHeight autoHeightMin={50} autoHeightMax={150}>
                                                  {this.state.tags.map((item, index) => (
                                                    <Chip
                                                      key={index}
                                                      label={item}
                                                      size="small"
                                                      onDelete={(chip) => this.removeChip(index)}
                                                      style={{ background: this.getColor(), color: "#fff", fontWeight: 600, marginTop: 5, marginLeft: 3 }}
                                                    />)
                                                  )}
                                                  <ChipInput
                                                    value={this.state.tags}
                                                    placeholder="Add a Tag"
                                                    onAdd={value => this.addChip(value)}
                                                  />
                                                </Scrollbars><br />
                                              </Col>
                                            </Row>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                      {/*1st*/}
                                      <Card className="card-plain">
                                        <CardHeader role="tab">
                                          <a
                                            aria-expanded={this.state.openedCollapses.includes(
                                              "collapseOne"
                                            )}
                                            href="#pablo"
                                            data-parent="#accordion"
                                            data-toggle="collapse"
                                            onClick={e => {
                                              e.preventDefault();
                                              this.collapsesToggle("collapseOne");
                                            }}
                                          >
                                            <label
                                              className="form-control-label"
                                              htmlFor="input-email"
                                            >  Input Source </label> &nbsp;<b><span style={styles.error}>{this.state.copiedinputsource2}</span></b>
                                            <i className="now-ui-icons arrows-1_minimal-down" />
                                          </a>
                                        </CardHeader>
                                        <Collapse
                                          role="tabpanel"
                                          isOpen={this.state.openedCollapses.includes(
                                            "collapseOne"
                                          )}
                                        >
                                          <CardBody>
                                            <Row>
                                              <Col lg="6">
                                                <FormGroup>
                                                  <Row>
                                                    <Button color="primary" style={{ marginLeft: "10px" }}
                                                      id="addStorageItem3"
                                                      size="sm"
                                                      onClick={
                                                        e => {
                                                          e.preventDefault()
                                                          this.setState({ chooseType: 'input' }, () => {
                                                            this.toggleAddStorageItem()
                                                          })
                                                        }
                                                      }
                                                    >
                                                      <span className="btn-label">
                                                        <i className="fas fa-plus-circle"></i>
                                                      </span>
                                                  &nbsp;Add
                                                </Button>
                                                    <Button color="link"
                                                      size="sm"
                                                      onClick={e => {
                                                        e.preventDefault()
                                                        this.removeAll('input')
                                                      }}
                                                    >
                                                      Remove All
                                                </Button>
                                                  </Row>
                                                  <div className={(this.state.setFiles_input.length + this.state.setFolders_input.length) > 7 ? "scrollit" : ""}>
                                                    <ListGroup>
                                                      {this.state.setFolders_input.map((item, index) => (
                                                        <ListGroupItem key={'input-' + index} className="project-item">
                                                          <a href={() => false} className="text-primary" style={styles.chaticon} onClick={e => this.OpenStorageView(item, e,this.state.hideCodeCells)}>
                                                            <i className="fas fa-folder pr-1"></i>
                                                            {item}
                                                            <i className="far fa-times-circle filepadding text-red fontRed" 
                                                              onClick={e => {
                                                                e.stopPropagation()
                                                                this.RemoveFiles(this.state.setFolders_input, item, 'input', true)
                                                              }}></i>
                                                          </a>
                                                        </ListGroupItem>
                                                      ))}
                                                      {this.state.setFiles_input.map((item, index) => (
                                                        <ListGroupItem key={'input-' + index} className="project-item">
                                                          <UncontrolledDropdown direction={(index > 4 ? "up" : "right")}>
                                                          <span className="file" data-type="file"
                                                            data_attr_id={"codeId"+index}
                                                            onContextMenu={this.handleClick}>
                                                            <a href={()=> false} className="text-primary"
                                                              style={styles.chaticon} >
                                                              <i className={getImageFile(imageFileExtension(item))}></i>
                                                              {item}
                                                              <i className="far fa-times-circle filepadding text-red fontRed"
                                                                onClick={e=> {
                                                                e.stopPropagation()
                                                                this.RemoveFiles(this.state.setFiles_input, item,
                                                                'input')
                                                                }}></i>
                                                            </a>
                                                          </span>
                                                            <DropdownToggle tag="span" id={"codeId"+index}>                                                            
                                                            </DropdownToggle>
                                                            <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                                              <DropdownItem
                                                                onClick={e => this.OpenStorageView(item, e,this.state.hideCodeCells)}
                                                              >
                                                                <span ><i className="fas fa-binoculars mr-2"></i> View</span>
                                                              </DropdownItem>
                                                              <DropdownItem
                                                                onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                                              >
                                                                <span ><i className="fas fa-download mr-2" /> Download</span>
                                                              </DropdownItem>
                                                              <DropdownItem
                                                                onClick={e => this.GetLink(item, e, 'inputsource2')}>
                                                                <div>
                                                                  <i className=" fas fa-link mr-2" />
                                                                  <span>Get Sharable Link</span>
                                                                </div>
                                                              </DropdownItem>
                                                            </DropdownMenu>
                                                          </UncontrolledDropdown>
                                                        </ListGroupItem>
                                                      ))}
                                                    </ListGroup>
                                                  </div>

                                                </FormGroup>
                                              </Col>

                                              <Col lg="3">
                                                <FormGroup className="mt-3">
                                                  <label>
                                                    <Input type="checkbox" id="inputfilescheck4" onChange={this.handleSaveInputFile} checked={this.state.inputFilesRequired} />{' '}
                                          Save Input Files
                                         </label>
                                                </FormGroup>
                                                {this.state.inputFilesRequired === true &&
                                                  <FormGroup className="mt-3">
                                                    <label >
                                                      <Input type="checkbox" id="inputfilescheck5" onChange={this.handleRerunSaveInputFile} checked={this.state.rerunFromSavedInputFiles} />{' '}
                                           Rerun from Saved Input
                                           </label>
                                                  </FormGroup>
                                                }
                                                <FormGroup>
                                                  <UncontrolledTooltip placement="top" target="addStorageItem3" delay={0}>
                                                    Add from Storage
                          </UncontrolledTooltip>
                                                  <Modal
                                                    size="xl"
                                                    className="add-storage-item-modal ModalWidth"
                                                    isOpen={this.state.showAddStorageModal}
                                                    toggle={this.toggleAddStorageItem}
                                                    backdrop="static"
                                                    returnFocusAfterClose={false}
                                                  >
                                                    <Card className=" shadow">
                                                      <CardBody>
                                                        <Tabs
                                                          defaultTab="DFRepo"
                                                          onChange={(tabId) => {
                                                            // console.log(tabId) 
                                                          }}
                                                        >
                                                          <TabList>
                                                            <Row>
                                                              <div className="col">
                                                                {/* <Tab tabFor="Recent" className="adddatatab"><i className="fas fa-sync-alt"></i>&nbsp; Recent</Tab> */}
                                                                <Tab tabFor="DFRepo" className="adddatatab"><img src={dfrepo} style={{ width: '20px', height: '20px' }} alt="" ></img> &nbsp; DF Repo</Tab>
                                                                {/* <Tab tabFor="Local"><i className="fas fa-desktop"></i>&nbsp; Local</Tab> */}
                                                                <Tab tabFor="Github" disabled className="adddatatab hideTab"><i className="fab fa-github"></i>&nbsp; Github</Tab>
                                                              </div>
                                                              <div className="col text-right">
                                                                <span style={{ cursor: 'pointer' }} onClick={e => this.cancelDialog()}>
                                                                  <i className="fas fa-times text-red mr-3"></i>
                                                                </span>
                                                              </div>
                                                            </Row>
                                                          </TabList>
                                                          {/* <Scrollbars autoHeight autoHeightMin={400}> */}
                                                          {/* <TabPanel tabId="Recent">
                                                        <p>Recent files</p>
                                                      </TabPanel> */}
                                                          <TabPanel tabId="DFRepo">
                                                            <ModalBody>
                                                              <Scrollbars autoHeight autoHeightMin={400}>
                                                                <CardBody className="border-top storage-content equalheight" onScroll={this.handleScroll}>

                                                                  <div className="clearfix">
                                                                    <Row>
                                                                      <Col md="6" xs="6">
                                                                        <span className="select-all">
                                                                          <i
                                                                            className={this.state.selectAllFilesClass}
                                                                            onClick={this.selectAllFilesClick}
                                                                          ></i>
                                                                        </span> Select All Files
                                        </Col>
                                                                      <Col md="2" xs="2">
                                                                        <span>File Size</span>
                                                                      </Col>
                                                                      <Col md="3" xs="3">
                                                                        <span>Date Created </span>
                                                                      </Col>
                                                                      <Col md="1" xs="1">
                                                                        <Button
                                                                          id="upload"
                                                                          color="link"
                                                                          onClick={this.toggleUpload} style={{ marginTop: '-3px' }}>
                                                                          <i className="fas fa-cloud-upload-alt"></i>
                                                                        </Button>
                                                                        <UncontrolledTooltip placement="top" target="upload" delay={0}>
                                                                          Upload
                                        </UncontrolledTooltip>
                                                                      </Col>
                                                                    </Row>

                                                                    <Modal
                                                                      centered
                                                                      className="upload-modal"
                                                                      isOpen={this.state.showUploadModal}
                                                                      toggle={this.toggleUpload}
                                                                      backdrop="static"
                                                                      returnFocusAfterClose={false}
                                                                    >
                                                                      <ModalHeader toggle={this.toggleUpload}>File Uploads</ModalHeader>
                                                                      <ModalBody>
                                                                        <FilePond ref={ref => this.pond = ref}
                                                                          allowMultiple={true}
                                                                          maxFiles={10}
                                                                          server={{
                                                                            process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {

                                                                              const CancelToken = axios.CancelToken;
                                                                              const source = CancelToken.source();

                                                                              const fileToBeUpload = file
                                                                              const currFolder = !this.state.currFolder ? '' : this.state.currFolder
                                                                              const objectName = path.join(currFolder, fileToBeUpload.name)
                                                                              StorageService.uploadObjectUrl(objectName, null, null)
                                                                                .then((response) => {
                                                                                  axios({
                                                                                    url: response.upload_url,
                                                                                    baseURL: '',
                                                                                    data: {},
                                                                                    headers: {
                                                                                      'content-type': fileToBeUpload.type,
                                                                                      'x-goog-resumable': 'start'
                                                                                    },
                                                                                    method: 'POST',
                                                                                    cancelToken: source.token
                                                                                  }).then((resp) => {
                                                                                    const resumableLink = resp.headers.location
                                                                                    console.log('Uploading...', fileToBeUpload.name)
                                                                                    CommonService({
                                                                                      url: resumableLink,
                                                                                      baseURL: '',
                                                                                      data: fileToBeUpload,
                                                                                      headers: {
                                                                                        'content-type': "multipart/form-data"
                                                                                      },
                                                                                      method: 'PUT',
                                                                                      cancelToken: source.token,
                                                                                      onUploadProgress: function (e) {
                                                                                        progress(e.lengthComputable, e.loaded, e.total)
                                                                                      }
                                                                                    }).then((resp) => {
                                                                                      load(fileToBeUpload.name)
                                                                                      // console.log('Uploaded!', fileToBeUpload.name)
                                                                                      this.fetchStorageItems(this.state.currFolder || '')
                                                                                    })
                                                                                  })
                                                                                })
                                                                              return {
                                                                                abort: () => {
                                                                                  // This function is entered if the user has tapped the cancel button
                                                                                  source.cancel()

                                                                                  // Let FilePond know the request has been cancelled
                                                                                  abort();
                                                                                }
                                                                              }
                                                                            }
                                                                          }}
                                                                        >
                                                                        </FilePond>
                                                                      </ModalBody>
                                                                    </Modal>
                                                                  </div>
                                                                  <AddStorageItems
                                                                    folders={this.state.storageFolders}
                                                                    files={this.state.storageFiles}
                                                                    fetchStorageItems={this.fetchStorageItems}
                                                                    loadmoreFlag={this.state.loadmoreFlag}
                                                                    nextPageToken={this.state.nextPageToken}
                                                                    chooseType={this.state.chooseType}
                                                                    storageFilesToBeAdded={this.state.storageFilesToBeAdded}
                                                                    storageFoldersToBeAdded={this.state.storageFoldersToBeAdded}
                                                                    updateStorageFiles={this.updateStorageFiles}
                                                                    updateStorageFolders={this.updateStorageFolders}
                                                                    selectAllFiles={this.state.selectAllFiles}
                                                                    selectAllFilesClass={this.state.selectAllFilesClass}
                                                                  />
                                                                </CardBody>
                                                                {this.state.nextPageToken === null && <Row>
                                                                  <Col style={{ textAlign: "center" }}>
                                                                    <span style={{ fontSize: 13, color: "#8c8b8b" }}>-- Page End --</span>
                                                                  </Col>
                                                                </Row>}
                                                              </Scrollbars>
                                                              <CardFooter className="storage-navigation">
                                                                <Row>
                                                                  <div className="col">
                                                                    <Breadcrumb listClassName="bg-transparent storage-nav-breadcrumb" listTag="div">
                                                                      {this.state.storageNavigations}
                                                                    </Breadcrumb>
                                                                  </div>
                                                                  <div className="col text-right">
                                                                    <Button color="secondary" style={{ marginLeft: "10px" }}
                                                                      id="addStorageItem4"
                                                                      size="sm"
                                                                      onClick={e => this.cancelDialog()} >
                                                                      <span className="btn-label">
                                                                        <i className="fas fa-times-circle"></i>
                                                                      </span>
                                &nbsp;Cancel
                              </Button>
                                                                    <Button style={{ marginLeft: "20px" }} color="primary"
                                                                      id="addStorageItem4"
                                                                      size="sm"
                                                                      onClick={e => this.SaveSelectedFiles()}>
                                                                      <span className="btn-label">
                                                                        <i className="fas fa-save"></i>
                                                                      </span>
                                &nbsp;Save
                              </Button>
                                                                  </div>
                                                                </Row>
                                                              </CardFooter>

                                                            </ModalBody>
                                                          </TabPanel>

                                                          <TabPanel tabId="Local">
                                                            <br></br>
                                                            <p>Local</p>
                                                          </TabPanel>
                                                          <TabPanel tabId="Github">
                                                            <p>Github</p>
                                                          </TabPanel>
                                                          {/* </Scrollbars> */}
                                                        </Tabs>
                                                      </CardBody>

                                                    </Card>
                                                  </Modal>
                                                </FormGroup>
                                              </Col>

                                              <Col lg="3">
                                                {this.state.recentFilesInput.length > 0 && <FormGroup>
                                                  <label
                                                    className="form-control-label"
                                                    htmlFor="input-first-name"
                                                  >
                                                    Recent uploads
                            </label>
                                                  {this.state.recentFilesInput.length > 0 && <div className="custom-control custom-control-alternative custom-checkbox">
                                                    <input
                                                      className="custom-control-input"
                                                      id=" customCheckLogin"
                                                      type="checkbox"
                                                      onChange={this.handleChangeInput}
                                                    />

                                                    <label
                                                      className="custom-control-label"
                                                      htmlFor=" customCheckLogin"
                                                    >
                                                    </label>
                                                  </div>}

                                                  {this.state.recentInputfolders.map(item => (

                                                    <div style={styles.leftAlign}>
                                                      <span
                                                      >
                                                        {item.folder}

                                                      </span>
                                                      <ul>
                                                        <li>
                                                          <span className="text-primary" ><a href={() => false}><u>{item.file}</u></a></span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  ))}

                                                </FormGroup>}
                                              </Col>
                                            </Row>

                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                      {/*2nd*/}
                                      <Card className="card-plain">
                                        <CardHeader role="tab">
                                          <a
                                            aria-expanded={this.state.openedCollapses.includes(
                                              "collapseTwo"
                                            )}
                                            href="#pablo"
                                            data-parent="#accordion"
                                            data-toggle="collapse"
                                            onClick={e => {
                                              e.preventDefault();
                                              this.collapsesToggle("collapseTwo");
                                            }}
                                          >
                                            <label
                                              className="form-control-label"
                                              htmlFor="input-email"
                                            > Code </label>  <b>&nbsp;<span style={styles.error}>{this.state.copiedcode2}</span></b>
                                            <i className="now-ui-icons arrows-1_minimal-down" />
                                          </a>
                                        </CardHeader>
                                        <Collapse
                                          role="tabpanel"
                                          isOpen={this.state.openedCollapses.includes(
                                            "collapseTwo"
                                          )}
                                        >
                                          <CardBody>
                                            {this.state.setFiles_code.length === 0 && this.state.setFolders_code.length === 0 && <Row>
                                              <Col>
                                                {this.state.hintCodeFiles}
                                              </Col>
                                            </Row>}
                                            <Row>
                                              <Col lg="6">
                                                <FormGroup>
                                                  <Row>
                                                    <Button color="primary" style={{ marginLeft: "10px" }}
                                                      id="addStorageItem5"
                                                      size="sm"
                                                      onClick={
                                                        e => {
                                                          e.preventDefault()
                                                          this.setState({ chooseType: 'code' }, () => {
                                                            this.toggleAddStorageItem()
                                                          })
                                                        }
                                                      }
                                                    >
                                                      <span className="btn-label">
                                                        <i className="now-ui-icons ui-1_simple-add"></i>
                                                      </span>
                                                  &nbsp;Add
                                                </Button>
                                                    <Button color="link"
                                                      size="sm"
                                                      onClick={e => {
                                                        e.preventDefault()
                                                        this.removeAll('code')
                                                      }}
                                                    >
                                                      Remove All
                                                </Button>
                                                  </Row>
                                                  <div className={(this.state.setFiles_code.length + this.state.setFolders_code.length) > 7 ? "scrollit" : ""}>
                                                    <ListGroup>
                                                      {this.state.setFolders_code.map((item, index) => (
                                                        <ListGroupItem key={'code-' + index} className="project-item">
                                                          <a href={() => false} className="text-primary" style={styles.chaticon} onClick={e => this.OpenStorageView(item, e,this.state.hideCodeCells)}>
                                                            <i className="fas fa-folder pr-1"></i>
                                                            {item}
                                                            <i className="far fa-times-circle filepadding text-red fontRed" 
                                                              onClick={e => {
                                                                e.stopPropagation()
                                                                this.RemoveFiles(this.state.setFolders_code, item, 'code', true)
                                                              }}></i>
                                                          </a>
                                                        </ListGroupItem>
                                                      ))}
                                                      {this.state.setFiles_code.map((item, index) => (
                                                        <ListGroupItem key={'code-' + index} className="project-item">
                                                            <UncontrolledDropdown direction={(index> 4 ? "up" : "right")}>
                                                            <span className="file" data-type="file"
                                                              data_attr_id={"codeId"+index+"a"}
                                                              onContextMenu={this.handleClick}
                                                              >
                                                              <a href={()=> false} className="text-primary"
                                                                style={styles.chaticon} >
                                                                <i
                                                                  className={getImageFile(imageFileExtension(item))}></i>
                                                                {item}
                                                                <i className="far fa-times-circle filepadding text-red fontRed"
                                                                  onClick={e=> {
                                                                  e.stopPropagation();
                                                                  this.RemoveFiles(this.state.setFiles_code, item,
                                                                  'code')
                                                                  }}></i>
                                                              </a>
                                                            </span>
                                                            <DropdownToggle tag="span" id={"codeId"+index+"a"}>
                                                            </DropdownToggle>
                                                              <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                                                <DropdownItem onClick={e=> this.OpenStorageView(item, e,this.state.hideCodeCells)}
                                                                  >
                                                                  <span>
                                                                    <i className="fas fa-binoculars mr-2"></i> View
                                                                  </span>
                                                                </DropdownItem>
                                                                <DropdownItem onClick={e=> this.downloadparticularFiles(item, item.runId, item.inputType)}
                                                                  >
                                                                  <span>
                                                                    <i className="fas fa-download mr-2" /> Download
                                                                  </span>
                                                                </DropdownItem>
                                                                <DropdownItem onClick={e=> this.GetLink(item, e, 'code2')}>
                                                                  <div>
                                                                    <i className=" fas fa-link mr-2" />
                                                                    <span>Get Sharable Link</span>
                                                                  </div>
                                                                </DropdownItem>
                                                              </DropdownMenu>
                                                            </UncontrolledDropdown>
                                                        </ListGroupItem>
                                                      ))}
                                                    </ListGroup>
                                                  </div>
                                                </FormGroup>
                                              </Col>
                                              <Col lg="3">
                                                <FormGroup className="mt-3">
                                                  <label>
                                                    <Input type="checkbox" id="inputcodefiles" onChange={this.handleSaveInputCode} checked={this.state.inputCodeFilesRequired} />{' '}
                                              Save Input Code Files
                                              </label>
                                                </FormGroup>
                                                {this.state.inputCodeFilesRequired === true &&
                                                  <FormGroup className="mt-3">
                                                    <label>
                                                      <Input type="checkbox" id="inputfilescheck6" onChange={this.handleRerunSaveInputFileCode} checked={this.state.rerunFromSavedCodeFiles} />{' '}
                                            Rerun from Saved Code
                                           </label>
                                                  </FormGroup>
                                                }
                                              </Col>
                                              <Col lg="3">
                                                {this.state.recentFilesCode.length > 0 && <FormGroup>
                                                  <label
                                                    className="form-control-label"
                                                    htmlFor="input-first-name"
                                                  >
                                                    Recent uploads
                            </label>
                                                  {this.state.recentFilesCode.length > 0 && <div className="custom-control custom-control-alternative custom-checkbox">
                                                    <input
                                                      className="custom-control-input"
                                                      id=" customCheckcode"
                                                      type="checkbox"
                                                      onChange={this.handleChangeCode}
                                                    />
                                                    <label
                                                      className="custom-control-label"
                                                      htmlFor=" customCheckcode"
                                                    >
                                                    </label>
                                                  </div>}

                                                  {this.state.recentCodefolders.map(item => (

                                                    <div style={styles.leftAlign}>
                                                      <span>
                                                        {item.folder}

                                                      </span>
                                                      <ul>
                                                        <li>
                                                          <span className="text-primary" ><a href={() => false}><u>{item.file}</u></a></span>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  ))}
                                                </FormGroup>}
                                              </Col>

                                            </Row>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                      {/*3rd*/}
                                      <Card className="card-plain">
                                        <CardHeader role="tab">
                                          <a
                                            aria-expanded={this.state.openedCollapses.includes(
                                              "collapseThree"
                                            )}
                                            href="#pablo"
                                            data-parent="#accordion"
                                            data-toggle="collapse"
                                            onClick={e => {
                                              e.preventDefault();
                                              this.collapsesToggle("collapseThree");
                                            }}
                                          >
                                            <label
                                              className="form-control-label"
                                              htmlFor="input-email"
                                            > Business Levers</label>
                                            <i className="now-ui-icons arrows-1_minimal-down" />
                                          </a>
                                        </CardHeader>
                                        <Collapse
                                          role="tabpanel"
                                          isOpen={this.state.openedCollapses.includes(
                                            "collapseThree"
                                          )}
                                        >
                                          <CardBody>
                                            <Row>
                                              <Col lg="6">
                                                <div>
                                                  <FilePond
                                                    files={this.state.files}
                                                    allowMultiple={true}
                                                    maxFiles={1}
                                                    labelIdle='Drag & Drop your files or <span className="filepond--label-action">Browse</span>'
                                                    server={{
                                                      // fake server to simulate loading a 'local' server file and processing a file
                                                      process: (fieldName, file, metadata, load) => {
                                                        // simulates uploading a file
                                                        setTimeout(() => {
                                                          load(Date.now());
                                                        }, 1500);
                                                      },
                                                      load: (source, load) => {
                                                        //console.log(source);
                                                        //console.log(load);
                                                        // simulates loading a file from the server
                                                        fetch(source)
                                                          .then(res => {
                                                            //console.log(res);
                                                            return res.blob();
                                                          })
                                                          .then(blob => {
                                                            //console.log(blob);
                                                            return load(blob);
                                                          });

                                                      }

                                                    }}
                                                    oninit={() => this.handleInit()}
                                                    onupdatefiles={fileItems => {
                                                      // Set currently active file objects to this.state
                                                      this.setState({
                                                        files: fileItems.map(fileItem => fileItem.file)
                                                      });
                                                      //console.log(this.state.files[0])
                                                      if (this.state.files.length > 0) {
                                                        var fr = new FileReader();
                                                        fr.readAsText(this.state.files[0]);
                                                        fr.onload = function (event) {
                                                          document.getElementById("textAreaParam").value = event.target.result;
                                                          //document.querySelector('.invisibleparameterSet').value=event.target.result;
                                                        }
                                                        setTimeout(() => {
                                                          this.getUploadedParameterSet();
                                                        }, 2500);

                                                      } else {
                                                        document.getElementById("textAreaParam").value = "";
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              </Col>
                                              <Col lg="5">
                                                <div onSubmit={this.getparametervalue}>
                                                  <Input
                                                    className="form-control-alternative "
                                                    placeholder="Parameters"
                                                    value={this.state.parameterSet}
                                                    rows="5"
                                                    style={{ display: 'none' }}
                                                    id="textAreaParam"
                                                    name="invisibleparameterSet"
                                                    onChange={this.handleChangeparam} noValidate
                                                    type="textarea"
                                                  />
                                                  {/* {this.state.parametersTablesdata.length > 0 && */}
                                                  <Table responsive className="table-hover paratbl" id="tab_logic">
                                                    <thead>
                                                      <tr>
                                                        <th>Variables </th>
                                                        <th style={{ width: "70%" }}> Values </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {this.state.parametersTablesdata.map((item, index) => (
                                                        item.row !== false &&
                                                        <tr id="addr0" key={index}>
                                                          <td>
                                                            <Input
                                                              className="form-control-alternative breaksen variabletxt"
                                                              value={this.state.parametersTablesdata[index].key}
                                                              style={{ border: 'none', borderRadius: '5px' }}
                                                              id={uuidv4()}
                                                              name="parameterSetkey"
                                                              onChange={(e) => this.handleChangeparam(index, 'key', e.target.value)}
                                                              noValidate
                                                              type="text"
                                                            />
                                                          </td>
                                                          <td style={{ width: "50%" }}>
                                                            <Input
                                                              className="form-control-alternative breaksen valuetxt"
                                                              value={item.value}
                                                              style={{ border: 'none', borderRadius: '5px' }}
                                                              id={uuidv4()}
                                                              name="parameterSet"
                                                              onChange={(e) => this.handleChangeparam(index, 'value', e.target.value)}
                                                              noValidate
                                                              type="text"
                                                            />
                                                          </td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </Table>
                                                  {/* } */}
                                                  {this.state.parametersTablesdata.length === 0 && <span style={{ color: 'darkgray', fontSize: '14px' }}>  &nbsp; No Business Levers Found</span>}
                                                </div>
                                              </Col>
                                              <Col lg="1">
                                                <br></br>
                                                <br></br>
                                                <img src={open} onClick={this.toggleModalParameter} style={{ cursor: 'pointer', width: '30px', height: '30px' }} alt="" />
                                                {/* {this.state.parametersTablesdata.length > 0 && <img src={open} onClick={this.toggleModalParameter} style={{ cursor: 'pointer', width: '30px', height: '30px' }} />} */}
                                              </Col>

                                            </Row>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                      {/*4th*/}
                                      <Card className="card-plain">
                                        <CardHeader role="tab">
                                          <a
                                            aria-expanded={this.state.openedCollapses.includes(
                                              "collapseFour"
                                            )}
                                            href="#pablo"
                                            data-parent="#accordion"
                                            data-toggle="collapse"
                                            onClick={e => {
                                              e.preventDefault();
                                              this.collapsesToggle("collapseFour");
                                            }}
                                          >
                                            <label
                                              className="form-control-label"
                                              htmlFor="input-email"
                                            > Dependencies / Libraries </label>
                                            <i className="now-ui-icons arrows-1_minimal-down" />
                                          </a>
                                        </CardHeader>
                                        <Collapse
                                          role="tabpanel"
                                          isOpen={this.state.openedCollapses.includes(
                                            "collapseFour"
                                          )}
                                        >
                                          <CardBody>
                                            <Row>
                                              <Col lg="6">
                                                <div>
                                                  <label
                                                    className="form-control-label"
                                                    htmlFor="input-email"
                                                  >
                                                    Python Libraries (as CSV)
                            </label>
                                                  <FilePond
                                                    files={this.state.pythonfiles}
                                                    allowMultiple={true}
                                                    maxFiles={1}
                                                    labelIdle='Drag & Drop your files or <span className="filepond--label-action">Browse</span>'
                                                    server={{
                                                      // fake server to simulate loading a 'local' server file and processing a file
                                                      process: (fieldName, file, metadata, load) => {
                                                        // simulates uploading a file
                                                        setTimeout(() => {
                                                          load(Date.now());
                                                        }, 1500);
                                                      },
                                                      load: (source, load) => {
                                                        // simulates loading a file from the server
                                                        fetch(source)
                                                          .then(res => {
                                                            //console.log(res);
                                                            return res.blob();
                                                          })
                                                          .then(blob => {
                                                            //console.log(blob);
                                                            return load(blob);
                                                          });
                                                      }
                                                    }}
                                                    oninit={() => this.handleInit()}
                                                    onupdatefiles={fileItems => {
                                                      // Set currently active file objects to this.state
                                                      this.setState({
                                                        pythonfiles: fileItems.map(fileItem => fileItem.file)
                                                      });
                                                      //console.log(this.state.files[0])
                                                      if (this.state.pythonfiles.length > 0) {
                                                        var fr = new FileReader();
                                                        fr.readAsText(this.state.pythonfiles[0]);
                                                        fr.onload = function (event) {
                                                          document.getElementById("textAreaPythonParam").value = event.target.result;
                                                        }
                                                      } else {
                                                        document.getElementById("textAreaPythonParam").value = "";
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              </Col>
                                              <Col lg="6">
                                                <FormGroup>
                                                  <Input
                                                    className="form-control-alternative"
                                                    placeholder="Python libraries"
                                                    // disabled
                                                    rows="4"
                                                    style={styles.rowAlign}
                                                    id="textAreaPythonParam"
                                                    type="textarea"
                                                    name="pyLibrary"
                                                    onChange={this.handleChange} noValidate
                                                  />
                                                </FormGroup>
                                                <span style={styles.textAreaHint}>Example: pandas==0.25.3, tensforflow, pytorch, python-opencv</span>
                                              </Col>
                                            </Row>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                      {/*5th*/}
                                      <Card className="card-plain" id="clusterName">
                                        <CardHeader role="tab">
                                          <a
                                            aria-expanded={this.state.openedCollapses.includes(
                                              "collapseFive"
                                            )}
                                            href="#pablo"
                                            data-parent="#accordion"
                                            data-toggle="collapse"
                                            onClick={e => {
                                              e.preventDefault();
                                              this.collapsesToggle("collapseFive");
                                            }}
                                          >
                                            <label
                                              className="form-control-label"
                                              htmlFor="input-email"
                                            > Compute Size </label>
                                            <i className="now-ui-icons arrows-1_minimal-down" />
                                          </a>
                                        </CardHeader>
                                        <Collapse
                                          role="tabpanel"
                                          isOpen={this.state.openedCollapses.includes(
                                            "collapseFive"
                                          )}
                                        >
                                          <CardBody>
                                            <Row>
                                              <Col lg="6">
                                                <FormGroup>
                                                  <label
                                                    className="form-control-label"
                                                    htmlFor="input-username"
                                                  >
                                                    Select a Machine Type / Cluster
                                            </label>
                                                  <Select name="clusterName"
                                                    value={this.state.clusteroptions.filter(item => item.value === this.state.clusterName)}
                                                    options={this.state.clusteroptions}
                                                    onChange={this.handleChangeSelect}
                                                    noValidate
                                                    className={this.state.hintVmCluster !== "" ? "df-error-outline" : ""} />

                                                </FormGroup>
                                                {this.state.hintVmCluster}
                                              </Col>
                                              <Col lg="6">
                                                <FormGroup>
                                                  <label
                                                    className="form-control-label"
                                                    htmlFor="input-username"
                                                  >
                                                    Runtime
                            </label>
                                                  <Select name="kernelName"
                                                    // value={{label : this.state.kernelName}}
                                                    value={this.state.runTimeOptions.filter(item => item.value === this.state.kernelId)}
                                                    options={this.state.runTimeOptions}
                                                    onChange={this.handleChangeSelectKernel}
                                                    noValidate
                                                    className={this.state.hintRunTime !== "" ? "df-error-outline" : ""} />
                                                </FormGroup>
                                                {this.state.hintRunTime}
                                              </Col>
                                            </Row>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                      {/*6th*/}
                                      <Card className="card-plain">
                                        <CardHeader role="tab">
                                          <a
                                            aria-expanded={this.state.openedCollapses.includes(
                                              "collapseSix"
                                            )}
                                            href="#pablo"
                                            data-parent="#accordion"
                                            data-toggle="collapse"
                                            onClick={e => {
                                              e.preventDefault();
                                              this.collapsesToggle("collapseSix");
                                            }}
                                          >
                                            <label
                                              className="form-control-label"
                                              htmlFor="input-email"
                                            > Others </label>
                                            <i className="now-ui-icons arrows-1_minimal-down" />
                                          </a>
                                        </CardHeader>
                                        <Collapse
                                          role="tabpanel"
                                          isOpen={this.state.openedCollapses.includes(
                                            "collapseSix"
                                          )}
                                        >
                                          <CardBody>
                                            <Row>
                                              <Col lg="6">
                                                <FormGroup>
                                                  <label
                                                    className="form-control-label"
                                                    htmlFor="input-username"
                                                  >
                                                    Choose File Delimiter
                            </label>
                                                  <Select name="delimiterName"
                                                    value={delimiteroptions.filter(item => item.value === this.state.delimiter)}
                                                    options={delimiteroptions} onChange={this.handleChangeSelectDelimiter} noValidate />
                                                </FormGroup>
                                              </Col>
                                              <Col lg="2">
</Col>
                                              <Col lg="4">
                                                            <FormGroup>
                                                              <br></br>
                                                                  <label>
                                                                    <Input type="checkbox" id="inputfilescheck3" onChange={this.handleHideModelCell} checked={this.state.hideCodeCells} />{' '}
                                            Hide Code Cells
                                           </label>
                                                                </FormGroup>
                                                            </Col>
                                            </Row>
                                          </CardBody>
                                        </Collapse>
                                      </Card>

                                    </div>

                                  </Col>
                                </Row>

                              </div>
                              // </Scrollbars>
                            }




                          </div>
                          <br></br>
                          <Row className="stickybuttons">
                            <hr className="my-4" />
                            <Col xs={12} md={6}>
                              <CardBody>
                                <div className="">
                                  <FormGroup>
                                    {(this.props.location.state.mode ===
                                      "editProject" ||
                                      // this.props.location.state.mode == "reRun" ||
                                      // this.props.location.state.mode ==
                                      //   "runProject" ||
                                      this.props.location.state.mode ===
                                      "cloneProject") && (
                                        <Button
                                          color="secondary"
                                          style={{ marginRight: 18 }}
                                          onClick={(e) => this.cancelProject()}
                                          size="sm"
                                        >
                                          <span className="btn-label">
                                            <i className="fas fa-times-circle"></i>
                                          </span>
                                    &nbsp; Cancel
                                        </Button>
                                      )}
                                    {(this.state.btnActions === "Update" || this.state.btnActions === "Save" || this.state.btnActions === "Clone") && <Button color="primary" type="submit" size="sm"><i className={this.state.iconaction}></i>&nbsp;{this.state.btnActions}</Button>}
                                   
                                    {(this.state.btnActions === "Run" || this.state.btnActions === "Re-Run") && <ButtonDropdown
                                      isOpen={this.state.runDropDown}
                                      toggle={this.toggleRunDropDown}
                                      size="sm"
                                    >
                                      <Button color="primary" onClick={this.SubmitProject} id={'runnow' + 0} className={this.state.blockreRun === true ? "disabled": ""}>
                                        <i className={this.state.iconaction + " fa-lg"}></i>
                                  &nbsp;<span className="btn-alignLeft">{this.state.btnActions}</span>
                                      </Button>

                                      <UncontrolledTooltip placement="top" target={'runnow' + 0} delay={0}>
                                        {this.state.btnActions}
                                      </UncontrolledTooltip>
                                      <DropdownToggle split className={this.state.blockreRun === true ? "btn btn-outline-primary disabled": "btn btn-outline-primary"} />
                                      <DropdownMenu>
                                        <DropdownItem
                                          onClick={this.toggleScheduler}
                                        >
                                          <i className="far fa-calendar-alt dropmenu-icon"></i>
                                      &nbsp; <span className="dropmenu-label">Schedule Later</span>
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </ButtonDropdown>}

                                  </FormGroup>
                                </div>
                              </CardBody>
                            </Col>
                            <Col xs={12} md={6}></Col>
                          </Row>

                        </Form>
                      </Scrollbars>

                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Modal isOpen={this.state.open} toggle={this.onCloseModal} backdrop="static">
                <div className="modal-header" toggle={this.onCloseModal}>
                  <h5 className="modal-title pull-left">Manage Clusters  </h5>
                  <div className="pull-right">
                    <Link to={{ pathname: '/cluster/Create' }}> <Button color="primary" href="#pablo" size="sm" style={{ marginRight: '35px', marginTop: '-6px' }}> New Cluster</Button> </Link>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
                <div className="reactmodalbody">
                  <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={500}>
                    <Card className="shadow">
                      <CardBody>
                        <ReactTable
                          data={this.state.modalclusterdetails}
                          columns={this.state.columns}
                          defaultPageSize={10}
                          showPaginationBottom={true}
                          className="-striped -highlight Providerstable"
                        />
                      </CardBody>
                    </Card>
                  </Scrollbars>

                </div>
              </Modal>
              <Modal isOpen={this.state.modalParameter} toggle={this.toggleModalParameter} className="modal-notice"
              backdrop="static">
                <ModalBody>
                  <Tabs defaultTab="Default View" onChange={(tabId) => {
                  }
                  }>
                    <TabList>
                      <Row>
                        <div className="col">
                          <Tab tabFor="Default View" className="adddatatab"> Default View</Tab>
                          <Tab tabFor="Detailed View" className="adddatatab"> Detailed View</Tab>
                          {/* {((this.props.location.state.mode == "editProject") || (this.props.location.state.mode == "addnew") || (this.props.location.state.mode == "cloneProject")) &&
                            <Tab tabFor="Configure" className="adddatatab"> Configure</Tab>
                          } */}
                        </div>
                        <div className="col text-right">
                          <span style={{ cursor: 'pointer' }} onClick={e => this.cancelDialog()}>
                            <i className="fas fa-times text-red mr-3"></i>
                          </span>
                        </div>
                      </Row>
                    </TabList>
                    <TabPanel tabId="Default View">
                      <CardBody>
                        <Table responsive className="table-hover paratbl" id="tab_logic" >
                          <thead>
                            <tr>
                              <th>Variables</th>
                              <th style={{ width: "70%" }}> Values </th>
                              <th> Action </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.parametersTablesdata.map((item, index) => (
                              item.row !== false &&
                              <tr id="addr0" key={index}>
                                <td><Input
                                  className="form-control-alternative breaksen variabletxt"
                                  value={this.state.parametersTablesdata[index].key}
                                  style={{ border: 'none', borderRadius: '5px' }}
                                  id={uuidv4()}
                                  name="parameterSetkey"
                                  onChange={(e) => this.handleChangeparam(index, 'key', e.target.value)}
                                  noValidate
                                  type="text"
                                />
                                </td>
                                <td style={{ width: "80%" }}>
                                  <Input
                                    className="form-control-alternative valuetxt"
                                    value={item.value}
                                    style={{ border: 'none', borderRadius: '5px' }}
                                    id={uuidv4()}
                                    name="parameterSet"
                                    onChange={(e) => this.handleChangeparam(index, 'value', e.target.value)}
                                    noValidate
                                    type="text"
                                  />
                                </td>
                                <td> <div className="">
                                  <div className="row">  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
         <UncontrolledDropdown direction={(index > 6 ? "up" : "down")}>
                                      <DropdownToggle
                                        tag="span"
                                        onClick={e => e.preventDefault()}
                                        style={{ color: '#007bff', cursor: 'pointer' }}
                                      >
                                        {/* <span className="actionicon" style={{ cursor: 'pointer' }} onClick={e => { e.preventDefault() }}><i className="fas fa-info-circle" title="Description"></i>&nbsp;</span> */}
                                      </DropdownToggle>
                                      <DropdownMenu
                                        persist right
                                        className="dropdown-menu-arrow"
                                      >
                                        <DropdownItem
                                          href=""
                                          onClick={e => {
                                            e.preventDefault()
                                            this.cloneProject(item.masterJobId, item.name, 'project')
                                          }}
                                        >
                                          <span>
                                            <div style={{ maxWidth: '400px' }} className="descriptiondialog">Some Description  [['Cass Freight Index-Shipments','Cass Freight Index-Expenditures','ProducerPriceIndex-Rail ranspor','Relative Importance Weight-Rail']]</div>
                                          </span>
                                        </DropdownItem>

                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                    <UncontrolledDropdown direction={(index > 6 ? "up" : "down")}>
                                      <DropdownToggle
                                        tag="span"
                                        onClick={e => e.preventDefault()}
                                        style={{ color: '#007bff', cursor: 'pointer' }}
                                      >
                                        <i className="fas fa-ellipsis-h"></i>
                                      </DropdownToggle>
                                      <DropdownMenu
                                        persist right
                                        className="dropdown-menu-arrow"
                                      >
                                        <DropdownItem
                                          href=""
                                          onClick={e => { e.preventDefault(); this.handleDeleteRow(index) }}
                                        >
                                          <span>
                                            <i className="fas fa-trash-alt text-red mr-3" /> Delete Row
                </span>
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </div>
                                </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        <i className="fas fa-plus-circle" onClick={this.handleAddRow} title="Add New Row"></i>
                      </CardBody>
                    </TabPanel>
                    <TabPanel tabId="Detailed View">
                      <CardBody>
                        <div>
                          <FormGroup>
                            <div onSubmit={this.getparametervalue}>
                              {/* <Input
                              className="form-control-alternative "
                              placeholder="Parameters"
                              value={this.state.detailedView_ParamSet}
                              rows="12"
                              style={{ maxHeight: '800px', marginTop: 28 }}
                              id="detailedviewParaSet"
                              name="parameterSet"
                              onChange={this.handleChangeDetailedparam}
                              noValidate
                              type="textarea"
                            /> */}
                              <Editor
                                className="codeStyleDetailView"
                                value={this.state.detailedView_ParamSet}
                                onValueChange={code => this.handleChangeDetailedparam(code)}
                                highlight={code => highlight(code, languages.py)}
                                padding={10}
                                id="detailedviewParaSet"
                              />
                            </div>
                          </FormGroup>
                        </div>
                      </CardBody>
                    </TabPanel>
                  </Tabs>
                </ModalBody>
              </Modal>
              <Modal isOpen={this.state.DeleteParameter} toggle={this.toggleModalParameter} className="modal-notice"
              backdrop="static">
                <ModalBody>
                  <div>
                    <FormGroup>
                      <Input
                        className="form-control-alternative "
                        placeholder="Parameters"
                        value={this.state.parameterSet}
                        // disabled
                        rows="12"
                        style={{ maxHeight: '800px', marginTop: 28 }}
                        id="textAreaParamm"
                        name="parameterSet"
                        onChange={this.handleChangeparam} noValidate
                        type="textarea"
                      />
                    </FormGroup>
                  </div>
                </ModalBody>
              </Modal>
              {/* Delete Parameter Modal */}
              <Modal isOpen={this.state.deleteParameter} toggle={this.CloseDeleteParameterModal} className="delete-modal"
              backdrop="static">
                <div className="modal-header">
                  <h5 className="modal-title pull-left">Delete Row</h5>
                </div>
                <div className="reactmodalbody">
                  <p> Are you sure to delete this row?</p>
                  <hr className="my-1" />
                  <Row style={{ maxHeight: '30px' }}>
                    <Col lg="2">
                      <FormGroup>
                        <Button
                          color="primary"
                          size="sm"
                          type="submit"
                          onClick={e => this.confirmDeleteRows(this.state.deleteindex)}
                        >
                          Delete
                     </Button>
                      </FormGroup>
                    </Col>
                    <Col lg="2">
                      <FormGroup>
                        <Button
                          color="secondary"
                          size="sm"
                          type="submit"
                          onClick={this.CloseDeleteParameterModal}
                        >
                          Cancel
                     </Button>
                      </FormGroup>

                    </Col>
                  </Row>

                </div>
              </Modal>
            </Row>
            <Scheduler
              ShowScheduler={this.state.showScheduler}
              ToggleScheduler={this.toggleScheduler}
              SchedulerMode="Create"
              SubmitScheduler={this.SubmitScheduleProject}
              ProjectName={this.state.projectName}
              ScheduleType={"Run"}
            />
          </LoadingOverlay>

        </div>
      </>
    );
  }
}
export default Project;
